
var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return n(r, t, e, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return n(r, t, e, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return n(r, t, e, a, u, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(n) {
        return r(7, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(c) {
                                    return n(r, t, e, a, u, i, c);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(n) {
        return r(8, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return function(c) {
                                    return function(o) {
                                        return n(r, t, e, a, u, i, c, o);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, a) {
        return 4 === n.a ? n.f(r, t, e, a) : n(r)(t)(e)(a);
    }
    function A5(n, r, t, e, a, u) {
        return 5 === n.a ? n.f(r, t, e, a, u) : n(r)(t)(e)(a)(u);
    }
    function A6(n, r, t, e, a, u, i) {
        return 6 === n.a ? n.f(r, t, e, a, u, i) : n(r)(t)(e)(a)(u)(i);
    }
    function A7(n, r, t, e, a, u, i, c) {
        return 7 === n.a ? n.f(r, t, e, a, u, i, c) : n(r)(t)(e)(a)(u)(i)(c);
    }
    function A8(n, r, t, e, a, u, i, c, o) {
        return 8 === n.a ? n.f(r, t, e, a, u, i, c, o) : n(r)(t)(e)(a)(u)(i)(c)(o);
    }
    function t(n, r) {
        for(var t, a = [], u = e(n, r, 0, a); u && (t = a.pop()); u = e(t.a, t.b, 0, a));
        return u;
    }
    function e(n, r, t, a) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && p(5), !1;
        if (t > 100) return a.push(i(n, r)), !0;
        for(var u in 0 > n.$ && (n = kr(n), r = kr(r)), n)if (!e(n[u], r[u], t + 1, a)) return !1;
        return !0;
    }
    function a(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = a(n.a, r.a)) || (t = a(n.b, r.b)) ? t : a(n.c, r.c);
        for(; n.b && r.b && !(t = a(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var u = F2(function(n, r) {
        var t = a(n, r);
        return 0 > t ? $r : t ? wr : mr;
    });
    function i(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function c(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function o(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function f(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = b(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = b(n.a, r);
        return t;
    }
    var s = {
        $: 0
    };
    function b(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var l = F2(b);
    function d(n) {
        for(var r = s, t = n.length; t--;)r = b(n[t], r);
        return r;
    }
    var v = F3(function(n, r, t) {
        for(var e = Array(n), a = 0; n > a; a++)e[a] = t(r + a);
        return e;
    }), h = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, i(t, r);
    });
    function p(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var g = Math.ceil, m = Math.floor, w = Math.round, $ = Math.log, x = F2(function(n, r) {
        return r.split(n);
    }), y = F2(function(n, r) {
        return r.join(n);
    }), k = F3(function(n, r, t) {
        return t.slice(n, r);
    }), j = F2(function(n, r) {
        return r.indexOf(n) > -1;
    }), K = F2(function(n, r) {
        return 0 === r.indexOf(n);
    }), A = F2(function(n, r) {
        var t = n.length;
        if (1 > t) return s;
        for(var e = 0, a = []; (e = r.indexOf(n, e)) > -1;)a.push(e), e += t;
        return d(a);
    });
    function C(n) {
        return n + "";
    }
    function J(n) {
        return {
            $: 2,
            b: n
        };
    }
    var L = J(function(n) {
        return "number" != typeof n ? I("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Jr(n) : !isFinite(n) || n % 1 ? I("an INT", n) : Jr(n);
    }), z = (J(function(n) {
        return "boolean" == typeof n ? Jr(n) : I("a BOOL", n);
    }), J(function(n) {
        return "number" == typeof n ? Jr(n) : I("a FLOAT", n);
    }));
    J(function(n) {
        return Jr(n);
    }), J(function(n) {
        return "string" == typeof n ? Jr(n) : n instanceof String ? Jr(n + "") : I("a STRING", n);
    });
    var S = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function N(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var _ = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), F = F2(function(n, r) {
        return N(n, [
            r
        ]);
    }), R = F3(function(n, r, t) {
        return N(n, [
            r,
            t
        ]);
    }), O = F2(function(n, r) {
        return H(n, r);
    });
    function H(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Jr(n.c) : I("null", r);
            case 3:
                return T(r) ? P(n.b, r, d) : I("a LIST", r);
            case 4:
                return T(r) ? P(n.b, r, E) : I("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return I("an OBJECT with a field named `" + t + "`", r);
                var e = H(n.b, r[t]);
                return it(e) ? e : jr(A2(Ar, t, e.a));
            case 7:
                var a = n.e;
                return T(r) ? r.length > a ? (e = H(n.b, r[a]), it(e) ? e : jr(A2(Cr, a, e.a))) : I("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : I("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || T(r)) return I("an OBJECT", r);
                var u = s;
                for(var c in r)if (r.hasOwnProperty(c)) {
                    if (e = H(n.b, r[c]), !it(e)) return jr(A2(Ar, c, e.a));
                    u = b(i(c, e.a), u);
                }
                return Jr(Pr(u));
            case 9:
                for(var o = n.f, f = n.g, l = 0; f.length > l; l++){
                    if (e = H(f[l], r), !it(e)) return e;
                    o = o(e.a);
                }
                return Jr(o);
            case 10:
                return e = H(n.b, r), it(e) ? H(n.h(e.a), r) : e;
            case 11:
                for(var v = s, h = n.g; h.b; h = h.b){
                    if (e = H(h.a, r), it(e)) return e;
                    v = b(e.a, v);
                }
                return jr(Lr(Pr(v)));
            case 1:
                return jr(A2(Kr, n.a, r));
            case 0:
                return Jr(n.a);
        }
    }
    function P(n, r, t) {
        for(var e = r.length, a = Array(e), u = 0; e > u; u++){
            var i = H(n, r[u]);
            if (!it(i)) return jr(A2(Cr, u, i.a));
            a[u] = i.a;
        }
        return Jr(t(a));
    }
    function T(n) {
        return Array.isArray(n) || "function" == typeof FileList && n instanceof FileList;
    }
    function E(n) {
        return A2(ut, n.length, function(r) {
            return n[r];
        });
    }
    function I(n, r) {
        return jr(A2(Kr, "Expecting " + n, r));
    }
    function Q(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return Q(n.b, r.b);
            case 6:
                return n.d === r.d && Q(n.b, r.b);
            case 7:
                return n.e === r.e && Q(n.b, r.b);
            case 9:
                return n.f === r.f && B(n.g, r.g);
            case 10:
                return n.h === r.h && Q(n.b, r.b);
            case 11:
                return B(n.g, r.g);
        }
    }
    function B(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!Q(n[e], r[e])) return !1;
        return !0;
    }
    function M(n) {
        return n;
    }
    var D = F3(function(n, r, t) {
        return t[n] = r, t;
    });
    function W(n) {
        return {
            $: 0,
            a: n
        };
    }
    function V(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var q = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), U = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), Z = 0;
    function G(n) {
        var r = {
            $: 0,
            e: Z++,
            f: n,
            g: null,
            h: []
        };
        return en(r), r;
    }
    function X(n) {
        return V(function(r) {
            r(W(G(n)));
        });
    }
    function Y(n, r) {
        n.h.push(r), en(n);
    }
    var nn = F2(function(n, r) {
        return V(function(t) {
            Y(n, r), t(W(0));
        });
    }), rn = !1, tn = [];
    function en(n) {
        if (tn.push(n), !rn) {
            for(rn = !0; n = tn.shift();)an(n);
            rn = !1;
        }
    }
    function an(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, en(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var un = {};
    function cn(n, r, t, e, a) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: a
        };
    }
    function on(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, a = n.d, u = n.e, i = n.f;
        function c(n) {
            return A2(q, c, {
                $: 5,
                b: function(r) {
                    var c = r.a;
                    return 0 === r.$ ? A3(a, t, c, n) : u && i ? A4(e, t, c.i, c.j, n) : A3(e, t, u ? c.i : c.j, n);
                }
            });
        }
        return t.h = G(A2(q, c, n.b));
    }
    var fn = F2(function(n, r) {
        return V(function(t) {
            n.g(r), t(W(0));
        });
    }), sn = F2(function(n, r) {
        return A2(nn, n.h, {
            $: 0,
            a: r
        });
    });
    function bn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function ln(n) {
        return {
            $: 2,
            m: n
        };
    }
    var dn = [], vn = !1;
    function hn(n, r, t) {
        if (dn.push({
            p: n,
            q: r,
            r: t
        }), !vn) {
            vn = !0;
            for(var e; e = dn.shift();)pn(e.p, e.q, e.r);
            vn = !1;
        }
    }
    function pn(n, r, t) {
        var e = {};
        for(var a in gn(!0, r, e, null), gn(!1, t, e, null), n)Y(n[a], {
            $: "fx",
            a: e[a] || {
                i: s,
                j: s
            }
        });
    }
    function gn(n, r, t, e) {
        switch(r.$){
            case 1:
                var a = r.k, u = function(n, r, t, e) {
                    function a(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? un[r].e : un[r].f, a, e);
                }(n, a, e, r.l);
                return void (t[a] = function(n, r, t) {
                    return t = t || {
                        i: s,
                        j: s
                    }, n ? t.i = b(r, t.i) : t.j = b(r, t.j), t;
                }(n, u, t[a]));
            case 2:
                for(var i = r.m; i.b; i = i.b)gn(n, i.a, t, e);
                return;
            case 3:
                return void gn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var mn, wn = F2(function(n, r) {
        return function(t) {
            return n(r(t));
        };
    });
    var $n = "undefined" != typeof document ? document : {};
    function xn(n, r) {
        n.appendChild(r);
    }
    function yn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var kn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: Hn(t),
                e: a,
                f: n,
                b: u
            };
        });
    }), jn = kn(void 0), Kn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var a = [], u = 0; e.b; e = e.b){
                var i = e.a;
                u += i.b.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: Hn(t),
                e: a,
                f: n,
                b: u
            };
        });
    })(void 0), An = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), Cn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), Jn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), Ln = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), zn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function Sn(n) {
        return "script" == n ? "p" : n;
    }
    function Nn(n) {
        return /^\s*(javascript:|data:text\/html)/i.test(n) ? "" : n;
    }
    var _n, Fn = F2(function(n, r) {
        return "a0" === r.$ ? A2(Cn, r.n, function(n, r) {
            var t = st(r);
            return {
                $: r.$,
                a: t ? A3(ot, 3 > t ? Rn : On, ft(n), r.a) : A2(ct, n, r.a)
            };
        }(n, r.o)) : r;
    }), Rn = F2(function(n, r) {
        return i(n(r.a), r.b);
    }), On = F2(function(n, r) {
        return {
            L: n(r.L),
            aX: r.aX,
            aS: r.aS
        };
    });
    function Hn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, a = t.n, u = t.o;
            if ("a2" !== e) {
                var i = r[e] || (r[e] = {});
                "a3" === e && "class" === a ? Pn(i, a, u) : i[a] = u;
            } else "className" === a ? Pn(r, a, M(u)) : r[a] = M(u);
        }
        return r;
    }
    function Pn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Tn(n, r) {
        var t = n.$;
        if (5 === t) return Tn(n.k || (n.k = n.m()), r);
        if (0 === t) return $n.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, a = n.j; 4 === e.$;)"object" != typeof a ? a = [
                a,
                e.j
            ] : a.push(e.j), e = e.k;
            var u = {
                j: a,
                p: r
            };
            return (i = Tn(e, u)).elm_event_node_ref = u, i;
        }
        if (3 === t) return En(i = n.h(n.g), r, n.d), i;
        var i = n.f ? $n.createElementNS(n.f, n.c) : $n.createElement(n.c);
        mn && "a" == n.c && i.addEventListener("click", mn(i)), En(i, r, n.d);
        for(var c = n.e, o = 0; c.length > o; o++)xn(i, Tn(1 === t ? c[o] : c[o].b, r));
        return i;
    }
    function En(n, r, t) {
        for(var e in t){
            var a = t[e];
            "a1" === e ? In(n, a) : "a0" === e ? Mn(n, r, a) : "a3" === e ? Qn(n, a) : "a4" === e ? Bn(n, a) : ("value" !== e && "checked" !== e || n[e] !== a) && (n[e] = a);
        }
    }
    function In(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Qn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Bn(n, r) {
        for(var t in r){
            var e = r[t], a = e.f, u = e.o;
            void 0 !== u ? n.setAttributeNS(a, t, u) : n.removeAttributeNS(a, t);
        }
    }
    function Mn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var a in t){
            var u = t[a], i = e[a];
            if (u) {
                if (i) {
                    if (i.q.$ === u.$) {
                        i.q = u;
                        continue;
                    }
                    n.removeEventListener(a, i);
                }
                i = Dn(r, u), n.addEventListener(a, i, _n && {
                    passive: 2 > st(u)
                }), e[a] = i;
            } else n.removeEventListener(a, i), e[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                _n = !0;
            }
        }));
    } catch (n) {}
    function Dn(n, r) {
        function t(r) {
            var e = t.q, a = H(e.a, r);
            if (it(a)) {
                for(var u, i = st(e), c = a.a, o = i ? 3 > i ? c.a : c.L : c, f = 1 == i ? c.b : 3 == i && c.aX, s = (f && r.stopPropagation(), (2 == i ? c.b : 3 == i && c.aS) && r.preventDefault(), n); u = s.j;){
                    if ("function" == typeof u) o = u(o);
                    else for(var b = u.length; b--;)o = u[b](o);
                    s = s.p;
                }
                s(o, f);
            }
        }
        return t.q = r, t;
    }
    function Wn(n, r) {
        return n.$ == r.$ && Q(n.a, r.a);
    }
    function Vn(n, r, t, e) {
        var a = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function qn(n, r, t, e) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void Vn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), a = 0; t > a; a++)e[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var i = n.l, c = r.l, o = i.length, f = o === c.length; f && o--;)f = i[o] === c[o];
                    if (f) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return qn(n.k, r.k, s, 0), void (s.length > 0 && Vn(t, 1, e, s));
                case 4:
                    for(var b = n.j, l = r.j, d = !1, v = n.k; 4 === v.$;)d = !0, "object" != typeof b ? b = [
                        b,
                        v.j
                    ] : b.push(v.j), v = v.k;
                    for(var h = r.k; 4 === h.$;)d = !0, "object" != typeof l ? l = [
                        l,
                        h.j
                    ] : l.push(h.j), h = h.k;
                    return d && b.length !== l.length ? void Vn(t, 0, e, r) : ((d ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(b, l) : b === l) || Vn(t, 2, e, l), void qn(v, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Vn(t, 3, e, r.a));
                case 1:
                    return void Un(n, r, t, e, Gn);
                case 2:
                    return void Un(n, r, t, e, Xn);
                case 3:
                    if (n.h !== r.h) return void Vn(t, 0, e, r);
                    var p = Zn(n.d, r.d);
                    p && Vn(t, 4, e, p);
                    var g = r.i(n.g, r.g);
                    return void (g && Vn(t, 5, e, g));
            }
        }
    }
    function Un(n, r, t, e, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = Zn(n.d, r.d);
            u && Vn(t, 4, e, u), a(n, r, t, e);
        } else Vn(t, 0, e, r);
    }
    function Zn(n, r, t) {
        var e;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], i = r[a];
                u === i && "value" !== a && "checked" !== a || "a0" === t && Wn(u, i) || ((e = e || {})[a] = i);
            } else (e = e || {})[a] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var c = Zn(n[a], r[a] || {}, a);
            c && ((e = e || {})[a] = c);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function Gn(n, r, t, e) {
        var a = n.e, u = r.e, i = a.length, c = u.length;
        i > c ? Vn(t, 6, e, {
            v: c,
            i: i - c
        }) : c > i && Vn(t, 7, e, {
            v: i,
            e: u
        });
        for(var o = c > i ? i : c, f = 0; o > f; f++){
            var s = a[f];
            qn(s, u[f], t, ++e), e += s.b || 0;
        }
    }
    function Xn(n, r, t, e) {
        for(var a = [], u = {}, i = [], c = n.e, o = r.e, f = c.length, s = o.length, b = 0, l = 0, d = e; f > b && s > l;){
            var v = (A = c[b]).a, h = (C = o[l]).a, p = A.b, g = C.b, m = void 0, w = void 0;
            if (v !== h) {
                var $ = c[b + 1], x = o[l + 1];
                if ($) {
                    var y = $.a, k = $.b;
                    w = h === y;
                }
                if (x) {
                    var j = x.a, K = x.b;
                    m = v === j;
                }
                if (m && w) qn(p, K, a, ++d), nr(u, a, v, g, l, i), d += p.b || 0, rr(u, a, v, k, ++d), d += k.b || 0, b += 2, l += 2;
                else if (m) d++, nr(u, a, h, g, l, i), qn(p, K, a, d), d += p.b || 0, b += 1, l += 2;
                else if (w) rr(u, a, v, p, ++d), d += p.b || 0, qn(k, g, a, ++d), d += k.b || 0, b += 2, l += 1;
                else {
                    if (!$ || y !== j) break;
                    rr(u, a, v, p, ++d), nr(u, a, h, g, l, i), d += p.b || 0, qn(k, K, a, ++d), d += k.b || 0, b += 2, l += 2;
                }
            } else qn(p, g, a, ++d), d += p.b || 0, b++, l++;
        }
        for(; f > b;){
            var A;
            d++, rr(u, a, (A = c[b]).a, p = A.b, d), d += p.b || 0, b++;
        }
        for(; s > l;){
            var C, J = J || [];
            nr(u, a, (C = o[l]).a, C.b, void 0, J), l++;
        }
        (a.length > 0 || i.length > 0 || J) && Vn(t, 8, e, {
            w: a,
            x: i,
            y: J
        });
    }
    var Yn = "_elmW6BL";
    function nr(n, r, t, e, a, u) {
        var i = n[t];
        if (!i) return u.push({
            r: a,
            A: i = {
                c: 0,
                z: e,
                r: a,
                s: void 0
            }
        }), void (n[t] = i);
        if (1 === i.c) {
            u.push({
                r: a,
                A: i
            }), i.c = 2;
            var c = [];
            return qn(i.z, e, c, i.r), i.r = a, void (i.s.s = {
                w: c,
                A: i
            });
        }
        nr(n, r, t + Yn, e, a, u);
    }
    function rr(n, r, t, e, a) {
        var u = n[t];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var i = [];
                return qn(e, u.z, i, a), void Vn(r, 9, a, {
                    w: i,
                    A: u
                });
            }
            rr(n, r, t + Yn, e, a);
        } else {
            var c = Vn(r, 9, a, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: a,
                s: c
            };
        }
    }
    function tr(n, r, t, e) {
        er(n, r, t, 0, 0, r.b, e);
    }
    function er(n, r, t, e, a, u, i) {
        for(var c = t[e], o = c.r; o === a;){
            var f = c.$;
            if (1 === f) tr(n, r.k, c.s, i);
            else if (8 === f) c.t = n, c.u = i, (s = c.s.w).length > 0 && er(n, r, s, 0, a, u, i);
            else if (9 === f) {
                c.t = n, c.u = i;
                var s, b = c.s;
                b && (b.A.s = n, (s = b.w).length > 0 && er(n, r, s, 0, a, u, i));
            } else c.t = n, c.u = i;
            if (!(c = t[++e]) || (o = c.r) > u) return e;
        }
        var l = r.$;
        if (4 === l) {
            for(var d = r.k; 4 === d.$;)d = d.k;
            return er(n, d, t, e, a + 1, u, n.elm_event_node_ref);
        }
        for(var v = r.e, h = n.childNodes, p = 0; v.length > p; p++){
            a++;
            var g = 1 === l ? v[p] : v[p].b, m = a + (g.b || 0);
            if (!(a > o || o > m || (c = t[e = er(h[p], g, t, e, a, m, i)]) && (o = c.r) <= u)) return e;
            a = m;
        }
        return e;
    }
    function ar(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], a = e.t, u = ur(a, e);
            a === n && (n = u);
        }
        return n;
    }
    function ur(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, a = Tn(r, t);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), e && a !== n && e.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return En(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return ar(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var a = (t = r.s).e, u = n.childNodes[e = t.v]; a.length > e; e++)n.insertBefore(Tn(a[e], r.u), u);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var i = t.A;
                return void 0 !== i.r && n.parentNode.removeChild(n), i.s = ar(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = $n.createDocumentFragment(), e = 0; n.length > e; e++){
                                var a = n[e].A;
                                xn(t, 2 === a.c ? a.s : Tn(a.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = ar(n, t.w);
                    for(var a = t.x, u = 0; a.length > u; u++){
                        var i = a[u], c = i.A, o = 2 === c.c ? c.s : Tn(c.z, r.u);
                        n.insertBefore(o, n.childNodes[i.r]);
                    }
                    return e && xn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                p(10);
        }
    }
    function ir(n) {
        if (3 === n.nodeType) return yn(n.textContent);
        if (1 !== n.nodeType) return yn("");
        for(var r = s, t = n.attributes, e = t.length; e--;){
            var a = t[e];
            r = b(A2(zn, a.name, a.value), r);
        }
        var u = n.tagName.toLowerCase(), i = s, c = n.childNodes;
        for(e = c.length; e--;)i = b(ir(c[e]), i);
        return A3(jn, u, r, i);
    }
    var cr = F4(function(n, r, t, e) {
        return function(n, r, t, e, a, u) {
            var i = A2(O, n, r ? r.flags : void 0);
            it(i) || p(2);
            var c = {}, o = (i = t(i.a)).a, f = u(b, o), s = function(n, r) {
                var t;
                for(var e in un){
                    var a = un[e];
                    a.a && ((t = t || {})[e] = a.a(e, r)), n[e] = on(a, r);
                }
                return t;
            }(c, b);
            function b(n, r) {
                f(o = (i = A2(e, n, o)).a, r), hn(c, i.b, a(o));
            }
            return hn(c, i.b, a(o)), s ? {
                ports: s
            } : {};
        }(r, e, n.cH, n.dH, n.dp, function(r, t) {
            var e = n.aV && n.aV(r), a = n.dJ, u = $n.title, i = $n.body, c = ir(i);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (or(e), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === t && (t = 1)) : (0 === t && or(e), t = 2);
                };
            }(t, function(n) {
                mn = e;
                var t = a(n), o = jn("body")(s)(t.b9), f = function(n, r) {
                    var t = [];
                    return qn(n, r, t, 0), t;
                }(c, o);
                i = function(n, r, t, e) {
                    return 0 === t.length ? n : (tr(n, r, t, e), ar(n, t));
                }(i, c, f, r), c = o, mn = 0, u !== t.C && ($n.title = u = t.C);
            });
        });
    }), or = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    function fr() {
        return Kt($n.location.href).a || p(1);
    }
    var sr = F2(function(n, r) {
        return A2(Bt, At, V(function() {
            history.pushState({}, "", r), n();
        }));
    }), br = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, lr = "undefined" != typeof document ? document : br, dr = "undefined" != typeof window ? window : br, vr = F3(function(n, r, t) {
        return X(V(function() {
            function e(n) {
                G(t(n));
            }
            return n.addEventListener(r, e, _n && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), hr = F2(function(n, r) {
        var t = H(n, r);
        return it(t) ? zr(t.a) : Sr;
    });
    function pr(n) {
        return V(function(r) {
            or(function() {
                r(W(n()));
            });
        });
    }
    var gr = F2(function(n, r) {
        return pr(function() {
            return dr.scroll(n, r), 0;
        });
    }), mr = 1, wr = 2, $r = 0, xr = l, yr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, a = n, u = A3(n, t.b, t.c, A3(yr, n, r, t.e));
            n = a, r = u, t = e;
        }
    }), kr = function(n) {
        return A3(yr, F3(function(n, r, t) {
            return A2(xr, i(n, r), t);
        }), s, n);
    }, jr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Kr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Ar = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Cr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Jr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Lr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, zr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Sr = {
        $: 1
    }, Nr = C, _r = F2(function(n, r) {
        return A2(y, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), Fr = F2(function(n, r) {
        return d(A2(x, n, r));
    }), Rr = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, a = n, u = A2(n, t.a, r);
            n = a, r = u, t = e;
        }
    }), Or = F3(function(n, r, t) {
        for(;;){
            if (a(n, r) >= 1) return t;
            var e = n, u = r - 1, i = A2(xr, r, t);
            n = e, r = u, t = i;
        }
    }), Hr = F2(function(n, r) {
        return A3(Or, n, r, s);
    }), Pr = function(n) {
        return A3(Rr, xr, s, n);
    }, Tr = 32, Er = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Ir = [], Qr = g, Br = F2(function(n, r) {
        return $(r) / $(n);
    }), Mr = function(n) {
        return n;
    }, Dr = Qr(A2(Br, 2, Tr)), Wr = A4(Er, 0, Dr, Ir, Ir), Vr = v, qr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ur = m, Zr = function(n) {
        return n.length;
    }, Gr = F2(function(n, r) {
        return a(n, r) > 0 ? n : r;
    }), Xr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Yr = h, nt = F2(function(n, r) {
        for(;;){
            var t = A2(Yr, Tr, n), e = t.b, a = A2(xr, Xr(t.a), r);
            if (!e.b) return Pr(a);
            n = e, r = a;
        }
    }), rt = function(n) {
        return n.a;
    }, tt = F2(function(n, r) {
        for(;;){
            var t = Qr(r / Tr);
            if (1 === t) return A2(Yr, Tr, n).a;
            n = A2(nt, n, s), r = t;
        }
    }), et = F2(function(n, r) {
        if (r.c) {
            var t = r.c * Tr, e = Ur(A2(Br, Tr, t - 1)), a = n ? Pr(r.g) : r.g, u = A2(tt, a, r.c);
            return A4(Er, Zr(r.f) + t, A2(Gr, 5, e * Dr), u, r.f);
        }
        return A4(Er, Zr(r.f), Dr, Ir, r.f);
    }), at = F5(function(n, r, t, e, a) {
        for(;;){
            if (0 > r) return A2(et, !1, {
                g: e,
                c: t / Tr | 0,
                f: a
            });
            var u = qr(A3(Vr, Tr, r, n));
            r -= Tr, e = A2(xr, u, e);
        }
    }), ut = F2(function(n, r) {
        if (n > 0) {
            var t = n % Tr;
            return A5(at, r, n - t - Tr, n, s, A3(Vr, t, n - t, r));
        }
        return Wr;
    }), it = function(n) {
        return !n.$;
    }, ct = F, ot = R, ft = function(n) {
        return {
            $: 0,
            a: n
        };
    }, st = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, bt = function(n) {
        return n;
    }, lt = bt, dt = F6(function(n, r, t, e, a, u) {
        return {
            bb: u,
            bh: r,
            bw: e,
            by: t,
            bB: n,
            bC: a
        };
    }), vt = j, ht = k, pt = F2(function(n, r) {
        return 1 > n ? r : A3(ht, n, r.length, r);
    }), gt = A, mt = function(n) {
        return "" === n;
    }, wt = F2(function(n, r) {
        return 1 > n ? "" : A3(ht, 0, n, r);
    }), $t = F5(function(n, r, t, e, a) {
        if (mt(a) || A2(vt, "@", a)) return Sr;
        var u = A2(gt, ":", a);
        if (u.b) {
            if (u.b.b) return Sr;
            var i = u.a, c = function(n) {
                for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, a = e; n.length > a; ++a){
                    var u = n.charCodeAt(a);
                    if (48 > u || u > 57) return Sr;
                    r = 10 * r + u - 48;
                }
                return a == e ? Sr : zr(45 == t ? -r : r);
            }(A2(pt, i + 1, a));
            if (1 === c.$) return Sr;
            var o = c;
            return zr(A6(dt, n, A2(wt, i, a), o, r, t, e));
        }
        return zr(A6(dt, n, a, Sr, r, t, e));
    }), xt = F4(function(n, r, t, e) {
        if (mt(e)) return Sr;
        var a = A2(gt, "/", e);
        if (a.b) {
            var u = a.a;
            return A5($t, n, A2(pt, u, e), r, t, A2(wt, u, e));
        }
        return A5($t, n, "/", r, t, e);
    }), yt = F3(function(n, r, t) {
        if (mt(t)) return Sr;
        var e = A2(gt, "?", t);
        if (e.b) {
            var a = e.a;
            return A4(xt, n, zr(A2(pt, a + 1, t)), r, A2(wt, a, t));
        }
        return A4(xt, n, Sr, r, t);
    }), kt = F2(function(n, r) {
        if (mt(r)) return Sr;
        var t = A2(gt, "#", r);
        if (t.b) {
            var e = t.a;
            return A3(yt, n, zr(A2(pt, e + 1, r)), A2(wt, e, r));
        }
        return A3(yt, n, Sr, r);
    }), jt = K, Kt = function(n) {
        return A2(jt, "http://", n) ? A2(kt, 0, A2(pt, 7, n)) : A2(jt, "https://", n) ? A2(kt, 1, A2(pt, 8, n)) : Sr;
    }, At = function() {
        for(;;);
    }, Ct = W, Jt = Ct(0), Lt = F4(function(n, r, t, e) {
        if (e.b) {
            var a = e.a, u = e.b;
            if (u.b) {
                var i = u.a, c = u.b;
                if (c.b) {
                    var o = c.a, f = c.b;
                    if (f.b) {
                        var s = f.b;
                        return A2(n, a, A2(n, i, A2(n, o, A2(n, f.a, t > 500 ? A3(Rr, n, r, Pr(s)) : A4(Lt, n, r, t + 1, s)))));
                    }
                    return A2(n, a, A2(n, i, A2(n, o, r)));
                }
                return A2(n, a, A2(n, i, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), zt = F3(function(n, r, t) {
        return A4(Lt, n, r, 0, t);
    }), St = F2(function(n, r) {
        return A3(zt, F2(function(r, t) {
            return A2(xr, n(r), t);
        }), s, r);
    }), Nt = q, _t = F2(function(n, r) {
        return A2(Nt, function(r) {
            return Ct(n(r));
        }, r);
    }), Ft = F3(function(n, r, t) {
        return A2(Nt, function(r) {
            return A2(Nt, function(t) {
                return Ct(A2(n, r, t));
            }, t);
        }, r);
    }), Rt = function(n) {
        return A3(zt, Ft(xr), Ct(s), n);
    }, Ot = fn, Ht = F2(function(n, r) {
        var t = r;
        return X(A2(Nt, Ot(n), t));
    });
    un.Task = cn(Jt, F3(function(n, r) {
        return A2(_t, function() {
            return 0;
        }, Rt(A2(St, Ht(n), r)));
    }), F3(function() {
        return Ct(0);
    }), F2(function(n, r) {
        return A2(_t, n, r);
    }));
    var Pt, Tt, Et, It, Qt = bn("Task"), Bt = F2(function(n, r) {
        return Qt(A2(_t, n, r));
    }), Mt = function(n) {
        return {
            $: 17,
            a: n
        };
    }, Dt = function(n) {
        return {
            $: 15,
            a: n
        };
    }, Wt = ln, Vt = {
        aJ: 0,
        c0: 0
    }, qt = {
        c7: {
            be: 0,
            bR: 0
        },
        bQ: {
            be: 0,
            bR: 0,
            dN: 0,
            dO: 0
        }
    }, Ut = pr(function() {
        var n, r;
        return {
            c7: (n = lr.body, r = lr.documentElement, {
                bR: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
                be: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
            }),
            bQ: {
                dN: dr.pageXOffset,
                dO: dr.pageYOffset,
                bR: lr.documentElement.clientWidth,
                be: lr.documentElement.clientHeight
            }
        };
    }), Zt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Gt = V(function(n) {
        n(W(A2(Zt, -(new Date).getTimezoneOffset(), s)));
    }), Xt = (Pt = bt, V(function(n) {
        n(W(Pt(Date.now())));
    })), Yt = F5(function(n, r, t, e, a) {
        return {
            S: e,
            W: t,
            O: r,
            H: a,
            Z: n
        };
    }), ne = function(n) {
        return n.b && ("" !== n.a || n.b.b) ? A2(xr, n.a, ne(n.b)) : s;
    }, re = F2(function(n, r) {
        return zr(1 === r.$ ? d([
            n
        ]) : A2(xr, n, r.a));
    }), te = function(n) {
        try {
            return zr(decodeURIComponent(n));
        } catch (n) {
            return Sr;
        }
    }, ee = u, ae = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return Sr;
            var t = r.c, e = r.d, a = r.e;
            switch(A2(ee, n, r.b)){
                case 0:
                    r = e;
                    continue n;
                case 1:
                    return zr(t);
                default:
                    r = a;
                    continue n;
            }
        }
    }), ue = F5(function(n, r, t, e, a) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), ie = {
        $: -2
    }, ce = F5(function(n, r, t, e, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(ue, n, r, t, e, a);
            var u = e.d;
            return i = e.e, A5(ue, 0, e.b, e.c, A5(ue, 1, u.b, u.c, u.d, u.e), A5(ue, 1, r, t, i, a));
        }
        var i, c = a.b, o = a.c, f = a.d, s = a.e;
        return -1 !== e.$ || e.a ? A5(ue, n, c, o, A5(ue, 0, r, t, e, f), s) : A5(ue, 0, r, t, A5(ue, 1, e.b, e.c, e.d, i = e.e), A5(ue, 1, c, o, f, s));
    }), oe = F3(function(n, r, t) {
        if (-2 === t.$) return A5(ue, 0, n, r, ie, ie);
        var e = t.a, a = t.b, u = t.c, i = t.d, c = t.e;
        switch(A2(ee, n, a)){
            case 0:
                return A5(ce, e, a, u, A3(oe, n, r, i), c);
            case 1:
                return A5(ue, e, a, r, i, c);
            default:
                return A5(ce, e, a, u, i, A3(oe, n, r, c));
        }
    }), fe = F3(function(n, r, t) {
        var e = A3(oe, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(ue, 1, e.b, e.c, e.d, e.e);
    }), se = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.e.d.$ || n.e.d.a) {
                var r = n.d, t = n.e;
                return i = t.b, c = t.c, e = t.d, s = t.e, A5(ue, 1, n.b, n.c, A5(ue, 0, r.b, r.c, r.d, r.e), A5(ue, 0, i, c, e, s));
            }
            var e, a = n.d, u = n.e, i = u.b, c = u.c, o = (e = u.d).d, f = e.e, s = u.e;
            return A5(ue, 0, e.b, e.c, A5(ue, 1, n.b, n.c, A5(ue, 0, a.b, a.c, a.d, a.e), o), A5(ue, 1, i, c, f, s));
        }
        return n;
    }, be = function(n) {
        if (-1 === n.$ && -1 === n.d.$ && -1 === n.e.$) {
            if (-1 !== n.d.d.$ || n.d.d.a) {
                var r = n.d, t = n.e;
                return f = t.b, s = t.c, b = t.d, l = t.e, A5(ue, 1, e = n.b, a = n.c, A5(ue, 0, r.b, r.c, r.d, c = r.e), A5(ue, 0, f, s, b, l));
            }
            var e = n.b, a = n.c, u = n.d, i = u.d, c = u.e, o = n.e, f = o.b, s = o.c, b = o.d, l = o.e;
            return A5(ue, 0, u.b, u.c, A5(ue, 1, i.b, i.c, i.d, i.e), A5(ue, 1, e, a, c, A5(ue, 0, f, s, b, l)));
        }
        return n;
    }, le = F7(function(n, r, t, e, a, u, i) {
        if (-1 !== u.$ || u.a) {
            n: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return be(r);
                        break n;
                    }
                    return be(r);
                }
                break n;
            }
            return r;
        }
        return A5(ue, t, u.b, u.c, u.d, A5(ue, 0, e, a, u.e, i));
    }), de = function(n) {
        if (-1 === n.$ && -1 === n.d.$) {
            var r = n.a, t = n.b, e = n.c, a = n.d, u = a.d, i = n.e;
            if (1 === a.a) {
                if (-1 !== u.$ || u.a) {
                    var c = se(n);
                    if (-1 === c.$) {
                        var o = c.e;
                        return A5(ce, c.a, c.b, c.c, de(c.d), o);
                    }
                    return ie;
                }
                return A5(ue, r, t, e, de(a), i);
            }
            return A5(ue, r, t, e, de(a), i);
        }
        return ie;
    }, ve = F2(function(n, r) {
        if (-2 === r.$) return ie;
        var t = r.a, e = r.b, u = r.c, i = r.d, c = r.e;
        if (0 > a(n, e)) {
            if (-1 === i.$ && 1 === i.a) {
                var o = i.d;
                if (-1 !== o.$ || o.a) {
                    var f = se(r);
                    if (-1 === f.$) {
                        var s = f.e;
                        return A5(ce, f.a, f.b, f.c, A2(ve, n, f.d), s);
                    }
                    return ie;
                }
                return A5(ue, t, e, u, A2(ve, n, i), c);
            }
            return A5(ue, t, e, u, A2(ve, n, i), c);
        }
        return A2(he, n, A7(le, n, r, t, e, u, i, c));
    }), he = F2(function(n, r) {
        if (-1 === r.$) {
            var e = r.a, a = r.b, u = r.c, i = r.d, c = r.e;
            if (t(n, a)) {
                var o = function(n) {
                    for(;;){
                        if (-1 !== n.$ || -1 !== n.d.$) return n;
                        n = n.d;
                    }
                }(c);
                return -1 === o.$ ? A5(ce, e, o.b, o.c, i, de(c)) : ie;
            }
            return A5(ce, e, a, u, i, A2(ve, n, c));
        }
        return ie;
    }), pe = F2(function(n, r) {
        var t = A2(ve, n, r);
        return -1 !== t.$ || t.a ? t : A5(ue, 1, t.b, t.c, t.d, t.e);
    }), ge = F3(function(n, r, t) {
        var e = r(A2(ae, n, t));
        return e.$ ? A2(pe, n, t) : A3(fe, n, e.a, t);
    }), me = F2(function(n, r) {
        var t = A2(Fr, "=", n);
        if (t.b && t.b.b && !t.b.b.b) {
            var e = t.b.a, a = te(t.a);
            if (1 === a.$) return r;
            var u = a.a, i = te(e);
            return 1 === i.$ ? r : A3(ge, u, re(i.a), r);
        }
        return r;
    }), we = ie, $e = F2(function(n, r) {
        var t;
        return function(n) {
            n: for(;;){
                if (n.b) {
                    var r = n.a, t = r.O;
                    if (t.b) {
                        if ("" !== t.a || t.b.b) {
                            n = n.b;
                            continue n;
                        }
                        return zr(r.H);
                    }
                    return zr(r.H);
                }
                return Sr;
            }
        }(n(A5(Yt, s, function(n) {
            var r = A2(Fr, "/", n);
            return ne(r.b && "" === r.a ? r.b : r);
        }(r.bw), 1 === (t = r.bC).$ ? we : A3(zt, me, we, A2(Fr, "&", t.a)), r.bb, bt)));
    }), xe = F2(function(n, r) {
        return A5(Yt, r.Z, r.O, r.W, r.S, n(r.H));
    }), ye = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = r.Z, a = r.O, u = r.W, i = r.S;
            return A2(St, xe(r.H), t(A5(Yt, e, a, u, i, n)));
        };
    }), ke = F2(function(n, r) {
        return r.b ? A3(zt, xr, r, n) : n;
    }), je = function(n) {
        return A3(zt, ke, s, n);
    }, Ke = F2(function(n, r) {
        return je(A2(St, n, r));
    }), Ae = F2(function(n, r) {
        return A3(zt, F2(function(r, t) {
            return n(r) ? A2(xr, r, t) : t;
        }), s, r);
    }), Ce = function(n) {
        return n.b ? zr(n.a) : Sr;
    }, Je = F2(function(n, r) {
        return t(r.a, n);
    }), Le = d([
        i(0, "home"),
        i(2, "support"),
        i(1, "aboutus"),
        i(3, "privacy")
    ]), ze = function(n) {
        var r = Ce(A2(Ae, Je(n), Le));
        return r.$ ? "" : r.a.b;
    }, Se = function(n) {
        return function(r) {
            var e = r.Z, a = r.O, u = r.W, i = r.S, c = r.H;
            if (a.b) {
                var o = a.a, f = a.b;
                return t(o, n) ? d([
                    A5(Yt, A2(xr, o, e), f, u, i, c)
                ]) : s;
            }
            return s;
        };
    }, Ne = function(n) {
        return d([
            n
        ]);
    }, _e = (Tt = d([
        A2(ye, 0, Ne),
        A2(ye, 0, Se(ze(0))),
        A2(ye, 2, Se(ze(2))),
        A2(ye, 1, Se(ze(1))),
        A2(ye, 3, Se(ze(3)))
    ]), function(n) {
        return A2(Ke, function(r) {
            return r(n);
        }, Tt);
    }), Fe = F2(function(n, r) {
        return Ur(n / r);
    }), Re = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r + n;
            var e = t.a, u = t.b;
            if (0 > a(e.aW, r)) return r + e.bs;
            t = u;
        }
    }), Oe = F2(function(n, r) {
        var t = n.b;
        return A3(Re, n.a, A2(Fe, r, 6e4), t);
    }), He = F2(function(n, r) {
        var t, e, a, u, i, c, o, f;
        return (t = A2(Oe, n, r), e = A2(Fe, t, 1440) + 719468, a = (0 > e ? e - 146096 : e) / 146097 | 0, u = e - 146097 * a, i = (u - (u / 1460 | 0) + (u / 36524 | 0) - (u / 146096 | 0)) / 365 | 0, c = u - (365 * i + (i / 4 | 0) - (i / 100 | 0)), o = (5 * c + 2) / 153 | 0, f = o + (10 > o ? 3 : -9), {
            a7: c - ((153 * o + 2) / 5 | 0) + 1,
            bq: f,
            dP: i + 400 * a + (f > 2 ? 0 : 1)
        }).dP;
    }), Pe = F3(function(n, r, t) {
        return i({
            a6: A2($e, _e, r),
            aK: Vt,
            bm: 0,
            cS: !1,
            cT: !1,
            cV: t,
            c8: "",
            df: !1,
            bN: !1,
            bQ: qt,
            dP: 0
        }, Wt(d([
            A2(Bt, Dt, Ut),
            A2(Bt, Mt, A3(Ft, He, Gt, Xt))
        ])));
    }), Te = F2(function(n, r) {
        return {
            $: 14,
            a: n,
            b: r
        };
    }), Ee = ln, Ie = _, Qe = S, Be = z, Me = (Et = "messageReceiver", It = A2(Ie, function(n) {
        return A2(Ie, function(r) {
            return ft({
                c7: r,
                bQ: n
            });
        }, A2(Qe, "scene", A2(Ie, function(n) {
            return A2(Ie, function(r) {
                return ft({
                    be: r,
                    bR: n
                });
            }, A2(Qe, "height", Be));
        }, A2(Qe, "width", Be))));
    }, A2(Qe, "viewport", A2(Ie, function(n) {
        return A2(Ie, function(r) {
            return A2(Ie, function(t) {
                return A2(Ie, function(e) {
                    return ft({
                        be: e,
                        bR: t,
                        dN: r,
                        dO: n
                    });
                }, A2(Qe, "height", Be));
            }, A2(Qe, "width", Be));
        }, A2(Qe, "x", Be));
    }, A2(Qe, "y", Be)))), function(n) {
        un[n] && p(3);
    }(Et), un[Et] = {
        f: wn,
        u: It,
        a: function(n, r) {
            var t = s, e = un[n].u, a = W(null);
            return un[n].b = a, un[n].c = F3(function(n, r) {
                return t = r, a;
            }), {
                send: function(n) {
                    var a = A2(O, e, n);
                    it(a) || p(4);
                    for(var u = a.a, i = t; i.b; i = i.b)r(i.a(u));
                }
            };
        }
    }, bn(Et)), De = L, We = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ve = F2(function(n, r) {
        return {
            bx: r,
            bJ: n
        };
    }), qe = Ct(A2(Ve, s, we)), Ue = function(n) {
        return i(f(n.a ? "w_" : "d_", n.b), n);
    }, Ze = function(n) {
        return A3(Rr, F2(function(n, r) {
            return A3(fe, n.a, n.b, r);
        }), we, n);
    }, Ge = function(n) {
        return V(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(W(0));
        });
    }, Xe = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, a = n, u = A3(n, t.b, t.c, A3(Xe, n, r, t.d));
            n = a, r = u, t = e;
        }
    }), Ye = F6(function(n, r, t, e, u, c) {
        var o = A3(Xe, F3(function(e, u, c) {
            n: for(;;){
                var o = c.a, f = c.b;
                if (o.b) {
                    var s = o.a, b = s.a, l = s.b, d = o.b;
                    if (0 > a(b, e)) {
                        c = i(d, A3(n, b, l, f));
                        continue n;
                    }
                    return a(b, e) > 0 ? i(o, A3(t, e, u, f)) : i(d, A4(r, b, l, u, f));
                }
                return i(o, A3(t, e, u, f));
            }
        }), i(kr(e), c), u), f = o.a, s = o.b;
        return A3(Rr, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), s, f);
    }), na = F2(function(n, r) {
        return {
            a9: r,
            bk: n
        };
    }), ra = sn, ta = F3(function(n, r, t) {
        return A2(_t, function(n) {
            return i(r, n);
        }, A3(vr, t.a ? dr : lr, t.b, function(t) {
            return A2(ra, n, A2(na, r, t));
        }));
    }), ea = F2(function(n, r) {
        return A3(Xe, fe, r, n);
    }), aa = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var a = e.c;
            return c(e.a, e.b, A2(xr, A3(ta, n, r, t), a));
        }), a = F3(function(n, r, t) {
            var e = t.b, a = t.c;
            return c(A2(xr, r, t.a), e, a);
        }), u = F4(function(n, r, t, e) {
            var a = e.c;
            return c(e.a, A3(fe, n, r, e.b), a);
        }), i = A2(St, Ue, r), o = A6(Ye, a, u, e, t.bx, Ze(i), c(s, we, s)), f = o.b, b = o.c;
        return A2(Nt, function(n) {
            return Ct(A2(Ve, i, A2(ea, f, Ze(n))));
        }, A2(Nt, function() {
            return Rt(b);
        }, Rt(A2(St, Ge, o.a))));
    }), ua = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(xr, e.a, t);
    }), ia = F2(function(n, r) {
        return A3(zt, ua(n), s, r);
    });
    un["Browser.Events"] = cn(qe, aa, F3(function(n, r, e) {
        var a = r.bk, u = r.a9, i = A2(ia, function(n) {
            var r = n.b.c;
            return t(n.a, a) ? A2(hr, r, u) : Sr;
        }, e.bJ);
        return A2(Nt, function() {
            return Ct(e);
        }, Rt(A2(St, Ot(n), i)));
    }), 0, F2(function(n, r) {
        return A3(We, r.a, r.b, A2(ct, n, r.c));
    }));
    var ca, oa, fa, sa, ba, la, da, va, ha, pa, ga, ma = bn("Browser.Events"), wa = F3(function(n, r, t) {
        return ma(A3(We, n, r, t));
    }), $a = F2(function(n, r) {
        return 0 > a(n, r) ? n : r;
    }), xa = w, ya = function(n) {
        return function(n) {
            var r, t;
            return {
                aJ: (r = A2($a, n.bR, n.be), t = A2(Gr, n.bR, n.be), 600 > r ? 0 : t > 1200 ? t > 1200 && 1920 >= t ? 2 : 3 : 1),
                c0: 0 > a(n.bR, n.be) ? 0 : 1
            };
        }({
            be: xa(n.bQ.be),
            bR: xa(n.bQ.bR)
        });
    }, ka = Wt(s), ja = sr, Ka = {
        $: 0
    }, Aa = gr, Ca = A2(Bt, function() {
        return Ka;
    }, A2(Aa, 0, 0)), Ja = F2(function(n, r) {
        return 1 === n.$ ? r : r + ":" + Nr(n.a);
    }), La = F3(function(n, r, t) {
        return 1 === r.$ ? t : f(t, f(n, r.a));
    }), za = "contentContainer", Sa = function(n) {
        return function(n, r) {
            return V(function(t) {
                or(function() {
                    var e = document.getElementById(n);
                    t(e ? W(r(e)) : {
                        $: 1,
                        a: lt(n)
                    });
                });
            });
        }(n, function(n) {
            return {
                c7: {
                    bR: n.scrollWidth,
                    be: n.scrollHeight
                },
                bQ: {
                    dN: n.scrollLeft,
                    dO: n.scrollTop,
                    bR: n.clientWidth,
                    be: n.clientHeight
                }
            };
        });
    }, Na = U, _a = F3(function(n, r, t) {
        return {
            c7: t.c7,
            bQ: {
                be: r,
                bR: n,
                dN: t.bQ.dN,
                dO: t.bQ.dO
            }
        };
    }), Fa = F2(function(n, r) {
        switch(n.$){
            case 11:
                return i(r, (c = r.bQ, A2(Bt, Dt, A2(Na, function() {
                    return Ct(c);
                }, Sa(za)))));
            case 15:
                var t = n.a;
                return i(o(r, {
                    aK: ya(t),
                    bN: t.bQ.dO > 0,
                    bQ: t
                }), ka);
            case 14:
                return i(o(r, {
                    aK: ya(u = A3(_a, n.a, n.b, r.bQ)),
                    bQ: u
                }), ka);
            case 16:
                return i(o(r, {
                    c8: n.a,
                    df: !r.df
                }), ka);
            case 1:
                return i(o(r, {
                    cS: !0
                }), ka);
            case 2:
                return i(o(r, {
                    cS: !1
                }), ka);
            case 3:
                return i(o(r, {
                    cT: !0
                }), ka);
            case 4:
                return i(o(r, {
                    cT: !1
                }), ka);
            case 5:
                return i(o(r, {
                    a6: zr(0)
                }), Wt(d([
                    Ca,
                    A2(ja, r.cV, "/")
                ])));
            case 8:
                return i(o(r, {
                    a6: zr(2)
                }), Wt(d([
                    Ca,
                    A2(ja, r.cV, ze(2))
                ])));
            case 6:
                return i(o(r, {
                    a6: zr(1)
                }), Wt(d([
                    Ca,
                    A2(ja, r.cV, ze(1))
                ])));
            case 7:
                return i(o(r, {
                    a6: zr(3)
                }), Wt(d([
                    Ca,
                    A2(ja, r.cV, ze(3))
                ])));
            case 9:
                return i(o(r, {
                    bm: 0
                }), ka);
            case 10:
                return i(o(r, {
                    bm: 1
                }), ka);
            case 12:
                return i(o(r, {
                    a6: A2($e, _e, n.a)
                }), ka);
            case 13:
                var e = n.a;
                return i(r, e.$ ? (a = e.a, A2(Bt, At, V(function() {
                    try {
                        dr.location = a;
                    } catch (n) {
                        $n.location.reload(!1);
                    }
                }))) : A2(ja, r.cV, function(n) {
                    return A3(La, "#", n.bb, A3(La, "?", n.bC, f(A2(Ja, n.by, f(n.bB ? "https://" : "http://", n.bh)), n.bw)));
                }(e.a)));
            case 17:
                return i(o(r, {
                    dP: n.a
                }), ka);
            default:
                return i(r, ka);
        }
        var a, u, c;
    }), Ra = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Oa = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Ha = function(n) {
        return n > 31 ? {
            $: 1,
            a: 1 << n - 32
        } : {
            $: 0,
            a: 1 << n
        };
    }, Pa = Ha(5), Ta = function(n) {
        return n.toLowerCase();
    }, Ea = function(n) {
        return d(n.trim().split(/\s+/g));
    }, Ia = F2(function(n, r) {
        return f(r, function() {
            switch(n.$){
                case 0:
                    return "serif";
                case 1:
                    return "sans-serif";
                case 2:
                    return "monospace";
                case 3:
                case 4:
                    return A2(_r, "-", Ea(Ta(n.a)));
                default:
                    return A2(_r, "-", Ea(Ta(n.a.cU)));
            }
        }());
    }), Qa = {
        $: 6
    }, Ba = function(n) {
        return n ? "\u958B\u767A\u8005\u306E\u6982\u8981" : "About Us";
    }, Ma = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Da = Ma(2), Wa = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Va = {
        $: 0
    }, qa = {
        $: 0
    }, Ua = "cx", Za = "cy", Ga = "acb", Xa = "accx", Ya = "accy", nu = "acr", ru = "al", tu = "ar", eu = "s", au = "bh", uu = "c", iu = "ctr", cu = "ccy", ou = "cl", fu = "cptr", su = "hc", bu = "he", lu = "hf", du = "hfp", vu = "fr", hu = "nb", pu = "ol", gu = "or", mu = "oq", wu = "pg", $u = "p", xu = "r", yu = "e", ku = "cap", ju = "t", Ku = "clr", Au = "wc", Cu = "we", Ju = "wf", Lu = "wfp", zu = "wrp", Su = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nu = {
        $: 0
    }, _u = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Fu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ru = F2(function(n, r) {
        switch(r.$){
            case 0:
                return n;
            case 1:
                return f(r.a, n);
            case 2:
                return f(n, r.a);
            default:
                return f(r.a, f(n, r.b));
        }
    }), Ou = F3(function(n, r, t) {
        switch(t.$){
            case 0:
                return r;
            case 1:
                return f(A2(St, function(r) {
                    return i(n, r);
                }, t.a), r);
            case 2:
                return f(r, A2(St, function(r) {
                    return i(n, r);
                }, e = t.a));
            default:
                var e = t.b;
                return f(A2(St, function(r) {
                    return i(n, r);
                }, t.a), f(r, A2(St, function(r) {
                    return i(n, r);
                }, e)));
        }
    }), Hu = Ha(41), Pu = Ha(40), Tu = Ha(42), Eu = Ha(43), Iu = function(n) {
        return n;
    }, Qu = F2(function(n, r) {
        return A2(Ln, n, Iu(r));
    }), Bu = Qu("className"), Mu = jn("div"), Du = we, Wu = function(n) {
        switch(n.$){
            case 0:
                return Nr(n.a) + "px";
            case 1:
                return "auto";
            case 2:
                return Nr(n.a) + "fr";
            case 3:
                var r = n.b;
                return "min" + (Nr(n.a) + Wu(r));
            default:
                return r = n.b, "max" + (Nr(n.a) + Wu(r));
        }
    }, Vu = function(n) {
        return Nr(xa(255 * n));
    }, qu = function(n) {
        switch(n.$){
            case 0:
                return Sr;
            case 1:
                var r = n.a, t = r.b, e = r.c;
                return zr("mv-" + Vu(r.a) + "-" + Vu(t) + "-" + Vu(e));
            default:
                var a = n.a, u = a.b, i = a.c, c = n.b, o = c.a, f = c.b, s = c.c, b = n.c, l = b.a, d = b.b, v = b.c, h = n.d;
                return zr("tfrm-" + Vu(a.a) + "-" + Vu(u) + "-" + Vu(i) + "-" + Vu(o) + "-" + Vu(f) + "-" + Vu(s) + "-" + Vu(l) + "-" + Vu(d) + "-" + Vu(v) + "-" + Vu(h));
        }
    }, Uu = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Zu = function(n) {
        switch(n.$){
            case 13:
            case 1:
            case 12:
                return u = n.a;
            case 0:
            case 3:
            case 4:
            case 5:
            case 7:
            case 6:
                return n.a;
            case 2:
                return "font-size-" + Nr(n.a);
            case 8:
                var r = n.a;
                return "grid-rows-" + A2(_r, "-", A2(St, Wu, r.c6)) + "-cols-" + A2(_r, "-", A2(St, Wu, r.D)) + "-space-x-" + Wu(r.dj.a) + "-space-y-" + Wu(r.dj.b);
            case 9:
                var t = n.a;
                return "gp grid-pos-" + Nr(t.z) + "-" + Nr(t.cm) + "-" + Nr(t.bR) + "-" + Nr(t.be);
            case 11:
                var e = n.a, a = n.b, u = function() {
                    switch(e){
                        case 0:
                            return "fs";
                        case 1:
                            return "hv";
                        default:
                            return "act";
                    }
                }();
                return A2(_r, " ", A2(St, function(n) {
                    var r = Zu(n);
                    return "" === r ? "" : r + "-" + u;
                }, a));
            default:
                return A2(Uu, "", qu(n.a));
        }
    }, Gu = F2(function(n, r) {
        return A3(fe, n, 0, r);
    }), Xu = F2(function(n, r) {
        return !A2(ae, n, r).$;
    }), Yu = F2(function(n, r) {
        return A2(Xu, n, r);
    }), ni = F2(function(n, r) {
        var t = r.a, e = r.b, a = Zu(n);
        return A2(Yu, a, t) ? r : i(A2(Gu, a, t), A2(xr, n, e));
    }), ri = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ti = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), ei = function(n) {
        return "." + n;
    }, ai = C, ui = function(n) {
        var r = n.b, t = n.c, e = n.d;
        return "rgba(" + Nr(xa(255 * n.a)) + "," + Nr(xa(255 * r)) + "," + Nr(xa(255 * t)) + "," + ai(e) + ")";
    }, ii = function(n) {
        return A2(_r, " ", A2(ia, bt, d([
            n.bj ? zr("inset") : Sr,
            zr(ai(n.bs.a) + "px"),
            zr(ai(n.bs.b) + "px"),
            zr(ai(n._) + "px"),
            zr(ai(n.ad) + "px"),
            zr(ui(n.aa))
        ])));
    }, ci = F2(function(n, r) {
        return r.$ ? Sr : zr(n(r.a));
    }), oi = F2(function(n, r) {
        var t = r.b;
        return i(n(r.a), t);
    }), fi = F2(function(n, r) {
        return i(r.a, n(r.b));
    }), si = function(n) {
        return d([
            A2(ti, ei("focus-within") + ":focus-within", A2(ia, bt, d([
                A2(ci, function(n) {
                    return A2(ri, "border-color", ui(n));
                }, n.cb),
                A2(ci, function(n) {
                    return A2(ri, "background-color", ui(n));
                }, n.b5),
                A2(ci, function(n) {
                    return A2(ri, "box-shadow", ii({
                        _: n._,
                        aa: n.aa,
                        bj: !1,
                        bs: A2(fi, Mr, A2(oi, Mr, n.bs)),
                        ad: n.ad
                    }));
                }, n.de),
                zr(A2(ri, "outline", "none"))
            ]))),
            A2(ti, ei(eu) + ":focus .focusable, " + ei(eu) + ".focusable:focus, .ui-slide-bar:focus + " + ei(eu) + " .focusable-thumb", A2(ia, bt, d([
                A2(ci, function(n) {
                    return A2(ri, "border-color", ui(n));
                }, n.cb),
                A2(ci, function(n) {
                    return A2(ri, "background-color", ui(n));
                }, n.b5),
                A2(ci, function(n) {
                    return A2(ri, "box-shadow", ii({
                        _: n._,
                        aa: n.aa,
                        bj: !1,
                        bs: A2(fi, Mr, A2(oi, Mr, n.bs)),
                        ad: n.ad
                    }));
                }, n.de),
                zr(A2(ri, "outline", "none"))
            ])))
        ]);
    }, bi = function(n) {
        return jn(Sn(n));
    }, li = F2(function(n, r) {
        return A2(Ln, function(n) {
            return "innerHTML" == n || "formAction" == n ? "data-" + n : n;
        }(n), Nn(r));
    }), di = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), vi = function(n) {
        return {
            $: 6,
            a: n
        };
    }, hi = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), pi = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), gi = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), mi = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), wi = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), $i = d([
        0,
        1,
        2,
        3,
        4,
        5
    ]), xi = function(n) {
        switch(n){
            case 0:
                return ei("ct");
            case 1:
                return ei("cb");
            case 2:
                return ei("cr");
            case 3:
                return ei(ou);
            case 4:
                return ei("ccx");
            default:
                return ei(cu);
        }
    }, yi = function(n) {
        switch(n){
            case 0:
                return ei("at");
            case 1:
                return ei("ab");
            case 2:
                return ei(tu);
            case 3:
                return ei(ru);
            case 4:
                return ei(Ua);
            default:
                return ei(Za);
        }
    }, ki = function(n) {
        return vi(A2(Ke, function(r) {
            var t = n(r), e = t.a, a = t.b;
            return d([
                A2(gi, xi(r), e),
                A2(hi, ei(eu), d([
                    A2(gi, yi(r), a)
                ]))
            ]);
        }, $i));
    }, ji = d([
        A2(mi, "display", "flex"),
        A2(mi, "flex-direction", "column"),
        A2(mi, "white-space", "pre"),
        A2(gi, ei("hbh"), d([
            A2(mi, "z-index", "0"),
            A2(hi, ei(au), d([
                A2(mi, "z-index", "-1")
            ]))
        ])),
        A2(gi, ei("sbt"), d([
            A2(hi, ei(ju), d([
                A2(gi, ei(lu), d([
                    A2(mi, "flex-grow", "0")
                ])),
                A2(gi, ei(Ju), d([
                    A2(mi, "align-self", "auto !important")
                ]))
            ]))
        ])),
        A2(hi, ei(su), d([
            A2(mi, "height", "auto")
        ])),
        A2(hi, ei(lu), d([
            A2(mi, "flex-grow", "100000")
        ])),
        A2(hi, ei(Ju), d([
            A2(mi, "width", "100%")
        ])),
        A2(hi, ei(Lu), d([
            A2(mi, "width", "100%")
        ])),
        A2(hi, ei(Au), d([
            A2(mi, "align-self", "flex-start")
        ])),
        ki(function(n) {
            switch(n){
                case 0:
                    return i(d([
                        A2(mi, "justify-content", "flex-start")
                    ]), d([
                        A2(mi, "margin-bottom", "auto !important"),
                        A2(mi, "margin-top", "0 !important")
                    ]));
                case 1:
                    return i(d([
                        A2(mi, "justify-content", "flex-end")
                    ]), d([
                        A2(mi, "margin-top", "auto !important"),
                        A2(mi, "margin-bottom", "0 !important")
                    ]));
                case 2:
                    return i(d([
                        A2(mi, "align-items", "flex-end")
                    ]), d([
                        A2(mi, "align-self", "flex-end")
                    ]));
                case 3:
                    return i(d([
                        A2(mi, "align-items", "flex-start")
                    ]), d([
                        A2(mi, "align-self", "flex-start")
                    ]));
                case 4:
                    return i(d([
                        A2(mi, "align-items", "center")
                    ]), d([
                        A2(mi, "align-self", "center")
                    ]));
                default:
                    return i(d([
                        A2(hi, ei(eu), d([
                            A2(mi, "margin-top", "auto"),
                            A2(mi, "margin-bottom", "auto")
                        ]))
                    ]), d([
                        A2(mi, "margin-top", "auto !important"),
                        A2(mi, "margin-bottom", "auto !important")
                    ]));
            }
        })
    ]), Ki = d([
        0,
        1,
        2,
        3,
        4,
        5
    ]), Ai = d([
        A2(pi, "html,body", d([
            A2(mi, "height", "100%"),
            A2(mi, "padding", "0"),
            A2(mi, "margin", "0")
        ])),
        A2(pi, f(ei(eu), f(ei(yu), ei("ic"))), d([
            A2(mi, "display", "block"),
            A2(gi, ei(lu), d([
                A2(hi, "img", d([
                    A2(mi, "max-height", "100%"),
                    A2(mi, "object-fit", "cover")
                ]))
            ])),
            A2(gi, ei(Ju), d([
                A2(hi, "img", d([
                    A2(mi, "max-width", "100%"),
                    A2(mi, "object-fit", "cover")
                ]))
            ]))
        ])),
        A2(pi, ei(eu) + ":focus", d([
            A2(mi, "outline", "none")
        ])),
        A2(pi, ei("ui"), d([
            A2(mi, "width", "100%"),
            A2(mi, "height", "auto"),
            A2(mi, "min-height", "100%"),
            A2(mi, "z-index", "0"),
            A2(gi, f(ei(eu), ei(lu)), d([
                A2(mi, "height", "100%"),
                A2(hi, ei(lu), d([
                    A2(mi, "height", "100%")
                ]))
            ])),
            A2(hi, ei(vu), d([
                A2(gi, ei(hu), d([
                    A2(mi, "position", "fixed"),
                    A2(mi, "z-index", "20")
                ]))
            ]))
        ])),
        A2(pi, ei(hu), d([
            A2(mi, "position", "relative"),
            A2(mi, "border", "none"),
            A2(mi, "display", "flex"),
            A2(mi, "flex-direction", "row"),
            A2(mi, "flex-basis", "auto"),
            A2(gi, ei(yu), ji),
            vi((oa = function(n) {
                switch(n){
                    case 0:
                        return A2(gi, ei("a"), d([
                            A2(mi, "position", "absolute"),
                            A2(mi, "bottom", "100%"),
                            A2(mi, "left", "0"),
                            A2(mi, "width", "100%"),
                            A2(mi, "z-index", "20"),
                            A2(mi, "margin", "0 !important"),
                            A2(hi, ei(lu), d([
                                A2(mi, "height", "auto")
                            ])),
                            A2(hi, ei(Ju), d([
                                A2(mi, "width", "100%")
                            ])),
                            A2(mi, "pointer-events", "none"),
                            A2(hi, "*", d([
                                A2(mi, "pointer-events", "auto")
                            ]))
                        ]));
                    case 1:
                        return A2(gi, ei("b"), d([
                            A2(mi, "position", "absolute"),
                            A2(mi, "bottom", "0"),
                            A2(mi, "left", "0"),
                            A2(mi, "height", "0"),
                            A2(mi, "width", "100%"),
                            A2(mi, "z-index", "20"),
                            A2(mi, "margin", "0 !important"),
                            A2(mi, "pointer-events", "none"),
                            A2(hi, "*", d([
                                A2(mi, "pointer-events", "auto")
                            ])),
                            A2(hi, ei(lu), d([
                                A2(mi, "height", "auto")
                            ]))
                        ]));
                    case 2:
                        return A2(gi, ei(gu), d([
                            A2(mi, "position", "absolute"),
                            A2(mi, "left", "100%"),
                            A2(mi, "top", "0"),
                            A2(mi, "height", "100%"),
                            A2(mi, "margin", "0 !important"),
                            A2(mi, "z-index", "20"),
                            A2(mi, "pointer-events", "none"),
                            A2(hi, "*", d([
                                A2(mi, "pointer-events", "auto")
                            ]))
                        ]));
                    case 3:
                        return A2(gi, ei(pu), d([
                            A2(mi, "position", "absolute"),
                            A2(mi, "right", "100%"),
                            A2(mi, "top", "0"),
                            A2(mi, "height", "100%"),
                            A2(mi, "margin", "0 !important"),
                            A2(mi, "z-index", "20"),
                            A2(mi, "pointer-events", "none"),
                            A2(hi, "*", d([
                                A2(mi, "pointer-events", "auto")
                            ]))
                        ]));
                    case 4:
                        return A2(gi, ei(vu), d([
                            A2(mi, "position", "absolute"),
                            A2(mi, "width", "100%"),
                            A2(mi, "height", "100%"),
                            A2(mi, "left", "0"),
                            A2(mi, "top", "0"),
                            A2(mi, "margin", "0 !important"),
                            A2(mi, "pointer-events", "none"),
                            A2(hi, "*", d([
                                A2(mi, "pointer-events", "auto")
                            ]))
                        ]));
                    default:
                        return A2(gi, ei(au), d([
                            A2(mi, "position", "absolute"),
                            A2(mi, "width", "100%"),
                            A2(mi, "height", "100%"),
                            A2(mi, "left", "0"),
                            A2(mi, "top", "0"),
                            A2(mi, "margin", "0 !important"),
                            A2(mi, "z-index", "0"),
                            A2(mi, "pointer-events", "none"),
                            A2(hi, "*", d([
                                A2(mi, "pointer-events", "auto")
                            ]))
                        ]));
                }
            }, A2(St, oa, Ki)))
        ])),
        A2(pi, ei(eu), d([
            A2(mi, "position", "relative"),
            A2(mi, "border", "none"),
            A2(mi, "flex-shrink", "0"),
            A2(mi, "display", "flex"),
            A2(mi, "flex-direction", "row"),
            A2(mi, "flex-basis", "auto"),
            A2(mi, "resize", "none"),
            A2(mi, "font-feature-settings", "inherit"),
            A2(mi, "box-sizing", "border-box"),
            A2(mi, "margin", "0"),
            A2(mi, "padding", "0"),
            A2(mi, "border-width", "0"),
            A2(mi, "border-style", "solid"),
            A2(mi, "font-size", "inherit"),
            A2(mi, "color", "inherit"),
            A2(mi, "font-family", "inherit"),
            A2(mi, "line-height", "1"),
            A2(mi, "font-weight", "inherit"),
            A2(mi, "text-decoration", "none"),
            A2(mi, "font-style", "inherit"),
            A2(gi, ei(zu), d([
                A2(mi, "flex-wrap", "wrap")
            ])),
            A2(gi, ei("notxt"), d([
                A2(mi, "-moz-user-select", "none"),
                A2(mi, "-webkit-user-select", "none"),
                A2(mi, "-ms-user-select", "none"),
                A2(mi, "user-select", "none")
            ])),
            A2(gi, ei(fu), d([
                A2(mi, "cursor", "pointer")
            ])),
            A2(gi, ei("ctxt"), d([
                A2(mi, "cursor", "text")
            ])),
            A2(gi, ei("ppe"), d([
                A2(mi, "pointer-events", "none !important")
            ])),
            A2(gi, ei("cpe"), d([
                A2(mi, "pointer-events", "auto !important")
            ])),
            A2(gi, ei(Ku), d([
                A2(mi, "opacity", "0")
            ])),
            A2(gi, ei(mu), d([
                A2(mi, "opacity", "1")
            ])),
            A2(gi, ei(f("hv", Ku)) + ":hover", d([
                A2(mi, "opacity", "0")
            ])),
            A2(gi, ei(f("hv", mu)) + ":hover", d([
                A2(mi, "opacity", "1")
            ])),
            A2(gi, ei(f("fcs", Ku)) + ":focus", d([
                A2(mi, "opacity", "0")
            ])),
            A2(gi, ei(f("fcs", mu)) + ":focus", d([
                A2(mi, "opacity", "1")
            ])),
            A2(gi, ei(f("atv", Ku)) + ":active", d([
                A2(mi, "opacity", "0")
            ])),
            A2(gi, ei(f("atv", mu)) + ":active", d([
                A2(mi, "opacity", "1")
            ])),
            A2(gi, ei("ts"), d([
                A2(mi, "transition", A2(_r, ", ", A2(St, function(n) {
                    return n + " 160ms";
                }, d([
                    "transform",
                    "opacity",
                    "filter",
                    "background-color",
                    "color",
                    "font-size"
                ]))))
            ])),
            A2(gi, ei("sb"), d([
                A2(mi, "overflow", "auto"),
                A2(mi, "flex-shrink", "1")
            ])),
            A2(gi, ei("sbx"), d([
                A2(mi, "overflow-x", "auto"),
                A2(gi, ei(xu), d([
                    A2(mi, "flex-shrink", "1")
                ]))
            ])),
            A2(gi, ei("sby"), d([
                A2(mi, "overflow-y", "auto"),
                A2(gi, ei(uu), d([
                    A2(mi, "flex-shrink", "1")
                ])),
                A2(gi, ei(yu), d([
                    A2(mi, "flex-shrink", "1")
                ]))
            ])),
            A2(gi, ei("cp"), d([
                A2(mi, "overflow", "hidden")
            ])),
            A2(gi, ei("cpx"), d([
                A2(mi, "overflow-x", "hidden")
            ])),
            A2(gi, ei("cpy"), d([
                A2(mi, "overflow-y", "hidden")
            ])),
            A2(gi, ei(Au), d([
                A2(mi, "width", "auto")
            ])),
            A2(gi, ei("bn"), d([
                A2(mi, "border-width", "0")
            ])),
            A2(gi, ei("bd"), d([
                A2(mi, "border-style", "dashed")
            ])),
            A2(gi, ei("bdt"), d([
                A2(mi, "border-style", "dotted")
            ])),
            A2(gi, ei("bs"), d([
                A2(mi, "border-style", "solid")
            ])),
            A2(gi, ei(ju), d([
                A2(mi, "white-space", "pre"),
                A2(mi, "display", "inline-block")
            ])),
            A2(gi, ei("it"), d([
                A2(mi, "line-height", "1.05"),
                A2(mi, "background", "transparent"),
                A2(mi, "text-align", "inherit")
            ])),
            A2(gi, ei(yu), ji),
            A2(gi, ei(xu), d([
                A2(mi, "display", "flex"),
                A2(mi, "flex-direction", "row"),
                A2(hi, ei(eu), d([
                    A2(mi, "flex-basis", "0%"),
                    A2(gi, ei(Cu), d([
                        A2(mi, "flex-basis", "auto")
                    ])),
                    A2(gi, ei("lnk"), d([
                        A2(mi, "flex-basis", "auto")
                    ]))
                ])),
                A2(hi, ei(lu), d([
                    A2(mi, "align-self", "stretch !important")
                ])),
                A2(hi, ei(du), d([
                    A2(mi, "align-self", "stretch !important")
                ])),
                A2(hi, ei(Ju), d([
                    A2(mi, "flex-grow", "100000")
                ])),
                A2(hi, ei(iu), d([
                    A2(mi, "flex-grow", "0"),
                    A2(mi, "flex-basis", "auto"),
                    A2(mi, "align-self", "stretch")
                ])),
                A2(hi, "u:first-of-type." + nu, d([
                    A2(mi, "flex-grow", "1")
                ])),
                A2(hi, "s:first-of-type." + Xa, d([
                    A2(mi, "flex-grow", "1"),
                    A2(hi, ei(Ua), d([
                        A2(mi, "margin-left", "auto !important")
                    ]))
                ])),
                A2(hi, "s:last-of-type." + Xa, d([
                    A2(mi, "flex-grow", "1"),
                    A2(hi, ei(Ua), d([
                        A2(mi, "margin-right", "auto !important")
                    ]))
                ])),
                A2(hi, "s:only-of-type." + Xa, d([
                    A2(mi, "flex-grow", "1"),
                    A2(hi, ei(Za), d([
                        A2(mi, "margin-top", "auto !important"),
                        A2(mi, "margin-bottom", "auto !important")
                    ]))
                ])),
                A2(hi, "s:last-of-type.accx ~ u", d([
                    A2(mi, "flex-grow", "0")
                ])),
                A2(hi, "u:first-of-type.acr ~ s." + Xa, d([
                    A2(mi, "flex-grow", "0")
                ])),
                ki(function(n) {
                    switch(n){
                        case 0:
                            return i(d([
                                A2(mi, "align-items", "flex-start")
                            ]), d([
                                A2(mi, "align-self", "flex-start")
                            ]));
                        case 1:
                            return i(d([
                                A2(mi, "align-items", "flex-end")
                            ]), d([
                                A2(mi, "align-self", "flex-end")
                            ]));
                        case 2:
                            return i(d([
                                A2(mi, "justify-content", "flex-end")
                            ]), s);
                        case 3:
                            return i(d([
                                A2(mi, "justify-content", "flex-start")
                            ]), s);
                        case 4:
                            return i(d([
                                A2(mi, "justify-content", "center")
                            ]), s);
                        default:
                            return i(d([
                                A2(mi, "align-items", "center")
                            ]), d([
                                A2(mi, "align-self", "center")
                            ]));
                    }
                }),
                A2(gi, ei("sev"), d([
                    A2(mi, "justify-content", "space-between")
                ])),
                A2(gi, ei("lbl"), d([
                    A2(mi, "align-items", "baseline")
                ]))
            ])),
            A2(gi, ei(uu), d([
                A2(mi, "display", "flex"),
                A2(mi, "flex-direction", "column"),
                A2(hi, ei(eu), d([
                    A2(mi, "flex-basis", "0px"),
                    A2(mi, "min-height", "min-content"),
                    A2(gi, ei(bu), d([
                        A2(mi, "flex-basis", "auto")
                    ]))
                ])),
                A2(hi, ei(lu), d([
                    A2(mi, "flex-grow", "100000")
                ])),
                A2(hi, ei(Ju), d([
                    A2(mi, "width", "100%")
                ])),
                A2(hi, ei(Lu), d([
                    A2(mi, "width", "100%")
                ])),
                A2(hi, ei(Au), d([
                    A2(mi, "align-self", "flex-start")
                ])),
                A2(hi, "u:first-of-type." + Ga, d([
                    A2(mi, "flex-grow", "1")
                ])),
                A2(hi, "s:first-of-type." + Ya, d([
                    A2(mi, "flex-grow", "1"),
                    A2(hi, ei(Za), d([
                        A2(mi, "margin-top", "auto !important"),
                        A2(mi, "margin-bottom", "0 !important")
                    ]))
                ])),
                A2(hi, "s:last-of-type." + Ya, d([
                    A2(mi, "flex-grow", "1"),
                    A2(hi, ei(Za), d([
                        A2(mi, "margin-bottom", "auto !important"),
                        A2(mi, "margin-top", "0 !important")
                    ]))
                ])),
                A2(hi, "s:only-of-type." + Ya, d([
                    A2(mi, "flex-grow", "1"),
                    A2(hi, ei(Za), d([
                        A2(mi, "margin-top", "auto !important"),
                        A2(mi, "margin-bottom", "auto !important")
                    ]))
                ])),
                A2(hi, "s:last-of-type.accy ~ u", d([
                    A2(mi, "flex-grow", "0")
                ])),
                A2(hi, "u:first-of-type.acb ~ s." + Ya, d([
                    A2(mi, "flex-grow", "0")
                ])),
                ki(function(n) {
                    switch(n){
                        case 0:
                            return i(d([
                                A2(mi, "justify-content", "flex-start")
                            ]), d([
                                A2(mi, "margin-bottom", "auto")
                            ]));
                        case 1:
                            return i(d([
                                A2(mi, "justify-content", "flex-end")
                            ]), d([
                                A2(mi, "margin-top", "auto")
                            ]));
                        case 2:
                            return i(d([
                                A2(mi, "align-items", "flex-end")
                            ]), d([
                                A2(mi, "align-self", "flex-end")
                            ]));
                        case 3:
                            return i(d([
                                A2(mi, "align-items", "flex-start")
                            ]), d([
                                A2(mi, "align-self", "flex-start")
                            ]));
                        case 4:
                            return i(d([
                                A2(mi, "align-items", "center")
                            ]), d([
                                A2(mi, "align-self", "center")
                            ]));
                        default:
                            return i(d([
                                A2(mi, "justify-content", "center")
                            ]), s);
                    }
                }),
                A2(hi, ei(iu), d([
                    A2(mi, "flex-grow", "0"),
                    A2(mi, "flex-basis", "auto"),
                    A2(mi, "width", "100%"),
                    A2(mi, "align-self", "stretch !important")
                ])),
                A2(gi, ei("sev"), d([
                    A2(mi, "justify-content", "space-between")
                ]))
            ])),
            A2(gi, ei("g"), d([
                A2(mi, "display", "-ms-grid"),
                A2(hi, ".gp", d([
                    A2(hi, ei(eu), d([
                        A2(mi, "width", "100%")
                    ]))
                ])),
                A2(wi, i("display", "grid"), d([
                    i("display", "grid")
                ])),
                (ca = function(n) {
                    switch(n){
                        case 0:
                            return d([
                                A2(mi, "justify-content", "flex-start")
                            ]);
                        case 1:
                            return d([
                                A2(mi, "justify-content", "flex-end")
                            ]);
                        case 2:
                            return d([
                                A2(mi, "align-items", "flex-end")
                            ]);
                        case 3:
                            return d([
                                A2(mi, "align-items", "flex-start")
                            ]);
                        case 4:
                            return d([
                                A2(mi, "align-items", "center")
                            ]);
                        default:
                            return d([
                                A2(mi, "justify-content", "center")
                            ]);
                    }
                }, vi(A2(Ke, function(n) {
                    return d([
                        A2(hi, ei(eu), d([
                            A2(gi, yi(n), ca(n))
                        ]))
                    ]);
                }, $i)))
            ])),
            A2(gi, ei(wu), d([
                A2(mi, "display", "block"),
                A2(hi, ei("s:first-child"), d([
                    A2(mi, "margin", "0 !important")
                ])),
                A2(hi, ei(eu + (yi(3) + ":first-child + .") + eu), d([
                    A2(mi, "margin", "0 !important")
                ])),
                A2(hi, ei(eu + (yi(2) + ":first-child + .") + eu), d([
                    A2(mi, "margin", "0 !important")
                ])),
                ki(function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 4:
                        default:
                            return i(s, s);
                        case 2:
                            return i(s, d([
                                A2(mi, "float", "right"),
                                A2(gi, "::after", d([
                                    A2(mi, "content", '""'),
                                    A2(mi, "display", "table"),
                                    A2(mi, "clear", "both")
                                ]))
                            ]));
                        case 3:
                            return i(s, d([
                                A2(mi, "float", "left"),
                                A2(gi, "::after", d([
                                    A2(mi, "content", '""'),
                                    A2(mi, "display", "table"),
                                    A2(mi, "clear", "both")
                                ]))
                            ]));
                    }
                })
            ])),
            A2(gi, ei("iml"), d([
                A2(mi, "white-space", "pre-wrap !important"),
                A2(mi, "height", "100%"),
                A2(mi, "width", "100%"),
                A2(mi, "background-color", "transparent")
            ])),
            A2(gi, ei("implw"), d([
                A2(gi, ei(yu), d([
                    A2(mi, "flex-basis", "auto")
                ]))
            ])),
            A2(gi, ei("imlp"), d([
                A2(mi, "white-space", "pre-wrap !important"),
                A2(mi, "cursor", "text"),
                A2(hi, ei("imlf"), d([
                    A2(mi, "white-space", "pre-wrap !important"),
                    A2(mi, "color", "transparent")
                ]))
            ])),
            A2(gi, ei($u), d([
                A2(mi, "display", "block"),
                A2(mi, "white-space", "normal"),
                A2(mi, "overflow-wrap", "break-word"),
                A2(gi, ei("hbh"), d([
                    A2(mi, "z-index", "0"),
                    A2(hi, ei(au), d([
                        A2(mi, "z-index", "-1")
                    ]))
                ])),
                A2(di, ei(ju), d([
                    A2(mi, "display", "inline"),
                    A2(mi, "white-space", "normal")
                ])),
                A2(di, ei($u), d([
                    A2(mi, "display", "inline"),
                    A2(gi, "::after", d([
                        A2(mi, "content", "none")
                    ])),
                    A2(gi, "::before", d([
                        A2(mi, "content", "none")
                    ]))
                ])),
                A2(di, ei(yu), d([
                    A2(mi, "display", "inline"),
                    A2(mi, "white-space", "normal"),
                    A2(gi, ei(Cu), d([
                        A2(mi, "display", "inline-block")
                    ])),
                    A2(gi, ei(vu), d([
                        A2(mi, "display", "flex")
                    ])),
                    A2(gi, ei(au), d([
                        A2(mi, "display", "flex")
                    ])),
                    A2(gi, ei("a"), d([
                        A2(mi, "display", "flex")
                    ])),
                    A2(gi, ei("b"), d([
                        A2(mi, "display", "flex")
                    ])),
                    A2(gi, ei(gu), d([
                        A2(mi, "display", "flex")
                    ])),
                    A2(gi, ei(pu), d([
                        A2(mi, "display", "flex")
                    ])),
                    A2(hi, ei(ju), d([
                        A2(mi, "display", "inline"),
                        A2(mi, "white-space", "normal")
                    ]))
                ])),
                A2(hi, ei(xu), d([
                    A2(mi, "display", "inline")
                ])),
                A2(hi, ei(uu), d([
                    A2(mi, "display", "inline-flex")
                ])),
                A2(hi, ei("g"), d([
                    A2(mi, "display", "inline-grid")
                ])),
                ki(function(n) {
                    switch(n){
                        case 0:
                        case 1:
                        case 4:
                        default:
                            return i(s, s);
                        case 2:
                            return i(s, d([
                                A2(mi, "float", "right")
                            ]));
                        case 3:
                            return i(s, d([
                                A2(mi, "float", "left")
                            ]));
                    }
                })
            ])),
            A2(gi, ".hidden", d([
                A2(mi, "display", "none")
            ])),
            A2(gi, ei("w1"), d([
                A2(mi, "font-weight", "100")
            ])),
            A2(gi, ei("w2"), d([
                A2(mi, "font-weight", "200")
            ])),
            A2(gi, ei("w3"), d([
                A2(mi, "font-weight", "300")
            ])),
            A2(gi, ei("w4"), d([
                A2(mi, "font-weight", "400")
            ])),
            A2(gi, ei("w5"), d([
                A2(mi, "font-weight", "500")
            ])),
            A2(gi, ei("w6"), d([
                A2(mi, "font-weight", "600")
            ])),
            A2(gi, ei("w7"), d([
                A2(mi, "font-weight", "700")
            ])),
            A2(gi, ei("w8"), d([
                A2(mi, "font-weight", "800")
            ])),
            A2(gi, ei("w9"), d([
                A2(mi, "font-weight", "900")
            ])),
            A2(gi, ei("i"), d([
                A2(mi, "font-style", "italic")
            ])),
            A2(gi, ei("sk"), d([
                A2(mi, "text-decoration", "line-through")
            ])),
            A2(gi, ei("u"), d([
                A2(mi, "text-decoration", "underline"),
                A2(mi, "text-decoration-skip-ink", "auto"),
                A2(mi, "text-decoration-skip", "ink")
            ])),
            A2(gi, f(ei("u"), ei("sk")), d([
                A2(mi, "text-decoration", "line-through underline"),
                A2(mi, "text-decoration-skip-ink", "auto"),
                A2(mi, "text-decoration-skip", "ink")
            ])),
            A2(gi, ei("tun"), d([
                A2(mi, "font-style", "normal")
            ])),
            A2(gi, ei("tj"), d([
                A2(mi, "text-align", "justify")
            ])),
            A2(gi, ei("tja"), d([
                A2(mi, "text-align", "justify-all")
            ])),
            A2(gi, ei("tc"), d([
                A2(mi, "text-align", "center")
            ])),
            A2(gi, ei("tr"), d([
                A2(mi, "text-align", "right")
            ])),
            A2(gi, ei("tl"), d([
                A2(mi, "text-align", "left")
            ])),
            A2(gi, ".modal", d([
                A2(mi, "position", "fixed"),
                A2(mi, "left", "0"),
                A2(mi, "top", "0"),
                A2(mi, "width", "100%"),
                A2(mi, "height", "100%"),
                A2(mi, "pointer-events", "none")
            ]))
        ]))
    ]), Ci = function(n) {
        return d([
            A2(pi, ".v-" + n, d([
                A2(mi, "font-feature-settings", '"' + n + '"')
            ])),
            A2(pi, ".v-" + n + "-off", d([
                A2(mi, "font-feature-settings", '"' + n + '" 0')
            ]))
        ]);
    }, Ji = je(d([
        A2(St, function(n) {
            return A2(pi, ".border-" + Nr(n), d([
                A2(mi, "border-width", Nr(n) + "px")
            ]));
        }, A2(Hr, 0, 6)),
        A2(St, function(n) {
            return A2(pi, ".font-size-" + Nr(n), d([
                A2(mi, "font-size", Nr(n) + "px")
            ]));
        }, A2(Hr, 8, 32)),
        A2(St, function(n) {
            return A2(pi, ".p-" + Nr(n), d([
                A2(mi, "padding", Nr(n) + "px")
            ]));
        }, A2(Hr, 0, 24)),
        d([
            A2(pi, ".v-smcp", d([
                A2(mi, "font-variant", "small-caps")
            ])),
            A2(pi, ".v-smcp-off", d([
                A2(mi, "font-variant", "normal")
            ]))
        ]),
        Ci("zero"),
        Ci("onum"),
        Ci("liga"),
        Ci("dlig"),
        Ci("ordn"),
        Ci("tnum"),
        Ci("afrc"),
        Ci("frac")
    ])), Li = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {" + ei(eu) + ei(xu) + " > " + ei(eu) + " { flex-basis: auto !important; } " + ei(eu) + ei(xu) + " > " + ei(eu) + ei(iu) + ' { flex-basis: auto !important; }}\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .s {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .s {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n', zi = function(n) {
        return A2(_r, "", n);
    }, Si = F2(function(n, r) {
        return {
            at: r,
            j: s,
            N: s,
            A: n
        };
    }), Ni = F2(function(n, r) {
        var t = n;
        return A3(zt, F2(function(n, r) {
            switch(n.$){
                case 0:
                    return o(r, {
                        N: A2(xr, i(n.a, n.b), r.N)
                    });
                case 3:
                    var e = n.a;
                    return o(r, {
                        j: A2(xr, {
                            at: "\n}",
                            j: s,
                            N: n.b,
                            A: "@supports (" + e.a + ":" + e.b + ") {" + t.A
                        }, r.j)
                    });
                case 5:
                    var a = n.b;
                    return o(r, {
                        j: A2(xr, A2(Ni, A2(Si, t.A + " + " + n.a, ""), a), r.j)
                    });
                case 1:
                    var u = n.b;
                    return o(r, {
                        j: A2(xr, A2(Ni, A2(Si, t.A + " > " + n.a, ""), u), r.j)
                    });
                case 2:
                    return u = n.b, o(r, {
                        j: A2(xr, A2(Ni, A2(Si, t.A + " " + n.a, ""), u), r.j)
                    });
                case 4:
                    var c = n.b;
                    return o(r, {
                        j: A2(xr, A2(Ni, A2(Si, f(t.A, n.a), ""), c), r.j)
                    });
                default:
                    var b = n.a;
                    return o(r, {
                        j: A2(xr, A2(Ni, A2(Si, t.A, ""), b), r.j)
                    });
            }
        }), t, r);
    }), _i = f(Li, (fa = f(Ai, Ji), sa = function(n) {
        return n.N.b ? n.A + "{" + function(n) {
            return zi(A2(St, function(n) {
                return n.a + ":" + n.b + ";";
            }, n));
        }(n.N) + n.at + "}" : "";
    }, ba = function(n) {
        var r = n;
        return f(sa(r), zi(A2(St, ba, r.j)));
    }, zi(A2(St, ba, A3(zt, F2(function(n, r) {
        var t = n.b;
        return A2(xr, A2(Ni, A2(Si, n.a, ""), t), r);
    }), s, fa))))), Fi = yn, Ri = function(n) {
        switch(n.cR){
            case 0:
                return A3(bi, "div", s, d([
                    A3(bi, "style", s, d([
                        Fi(_i)
                    ]))
                ]));
            case 1:
                return Fi("");
            default:
                return A3(bi, "elm-ui-static-rules", d([
                    A2(li, "rules", Iu(_i))
                ]), s);
        }
    }, Oi = F2(function(n, r) {
        return A3(Rr, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), Hi = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Pi = function(n) {
        switch(n.$){
            case 0:
                return "serif";
            case 1:
                return "sans-serif";
            case 2:
                return "monospace";
            case 3:
            case 4:
                return '"' + n.a + '"';
            default:
                return '"' + n.a.cU + '"';
        }
    }, Ti = function(n) {
        switch(n.$){
            case 0:
                return "smcp" === n.a;
            case 1:
                return !1;
            default:
                return "smcp" === n.a && 1 === n.b;
        }
    }, Ei = function(n) {
        return 5 === n.$ && A2(Hi, Ti, n.a.bO);
    }, Ii = F3(function(n, r, t) {
        var e = r.a, a = r.b;
        return n ? t + "\n  " + e + ": " + a + " !important;" : t + "\n  " + e + ": " + a + ";";
    }), Qi = F4(function(n, r, t, e) {
        if (1 === r.$) return d([
            t + "{" + A3(Rr, Ii(!1), "", e) + "\n}"
        ]);
        switch(r.a){
            case 1:
                switch(n.cC){
                    case 0:
                        return s;
                    case 2:
                        return d([
                            t + "-hv {" + A3(Rr, Ii(!0), "", e) + "\n}"
                        ]);
                    default:
                        return d([
                            t + "-hv:hover {" + A3(Rr, Ii(!1), "", e) + "\n}"
                        ]);
                }
            case 0:
                var a = A3(Rr, Ii(!1), "", e);
                return d([
                    t + "-fs:focus {" + a + "\n}",
                    ".s:focus " + t + "-fs  {" + a + "\n}",
                    t + "-fs:focus-within {" + a + "\n}",
                    ".ui-slide-bar:focus + " + ei(eu) + " .focusable-thumb" + t + "-fs {" + a + "\n}"
                ]);
            default:
                return d([
                    t + "-act:active {" + A3(Rr, Ii(!1), "", e) + "\n}"
                ]);
        }
    }), Bi = function(n) {
        switch(n.$){
            case 0:
                return '"' + n.a + '"';
            case 1:
                return '"' + n.a + '" 0';
            default:
                return '"' + n.a + '" ' + Nr(n.b);
        }
    }, Mi = function(n) {
        return 5 === n.$ ? zr(A2(_r, ", ", A2(St, Bi, n.a.bO))) : Sr;
    }, Di = F3(function(n, r, t) {
        switch(r.$){
            case 0:
                return A4(Qi, n, t, r.a, r.b);
            case 13:
                return A4(Qi, n, t, "." + (a = r.a), d([
                    A2(ri, "box-shadow", r.b)
                ]));
            case 12:
                return A4(Qi, n, t, "." + (a = r.a), d([
                    A2(ri, "opacity", ai(A2(Gr, 0, A2($a, 1, 1 - r.b))))
                ]));
            case 2:
                var e = r.a;
                return A4(Qi, n, t, ".font-size-" + Nr(e), d([
                    A2(ri, "font-size", Nr(e) + "px")
                ]));
            case 1:
                var a = r.a, u = r.b, c = A2(_r, ", ", A2(ia, Mi, u)), o = d([
                    A2(ri, "font-family", A2(_r, ", ", A2(St, Pi, u))),
                    A2(ri, "font-feature-settings", c),
                    A2(ri, "font-variant", A2(Hi, Ei, u) ? "small-caps" : "normal")
                ]);
                return A4(Qi, n, t, "." + a, o);
            case 3:
                return A4(Qi, n, t, "." + (P = r.a), d([
                    A2(ri, r.b, E = r.c)
                ]));
            case 4:
                return A4(Qi, n, t, "." + (P = r.a), d([
                    A2(ri, r.b, ui(r.c))
                ]));
            case 5:
                var b = r.a, l = r.b, v = r.c, h = Nr(v) + "px", p = Nr(l) + "px", g = ".ar", m = ".p", w = ".pg", $ = ".al", x = ai(v / 2) + "px", y = ai(l / 2) + "px", k = ".s";
                return je(d([
                    A4(Qi, n, t, (P = "." + b) + ".r > " + ".s + " + k, d([
                        A2(ri, "margin-left", p)
                    ])),
                    A4(Qi, n, t, P + ".wrp.r > " + k, d([
                        A2(ri, "margin", x + " " + y)
                    ])),
                    A4(Qi, n, t, P + ".c > " + ".s + " + k, d([
                        A2(ri, "margin-top", h)
                    ])),
                    A4(Qi, n, t, P + (w + " > ") + ".s + " + k, d([
                        A2(ri, "margin-top", h)
                    ])),
                    A4(Qi, n, t, P + (w + " > ") + $, d([
                        A2(ri, "margin-right", p)
                    ])),
                    A4(Qi, n, t, P + (w + " > ") + g, d([
                        A2(ri, "margin-left", p)
                    ])),
                    A4(Qi, n, t, f(P, m), d([
                        A2(ri, "line-height", "calc(1em + " + Nr(v) + "px)")
                    ])),
                    A4(Qi, n, t, "textarea" + (k + P), d([
                        A2(ri, "line-height", "calc(1em + " + Nr(v) + "px)"),
                        A2(ri, "height", "calc(100% + " + Nr(v) + "px)")
                    ])),
                    A4(Qi, n, t, P + ".p > " + $, d([
                        A2(ri, "margin-right", p)
                    ])),
                    A4(Qi, n, t, P + ".p > " + g, d([
                        A2(ri, "margin-left", p)
                    ])),
                    A4(Qi, n, t, P + ".p::after", d([
                        A2(ri, "content", "''"),
                        A2(ri, "display", "block"),
                        A2(ri, "height", "0"),
                        A2(ri, "width", "0"),
                        A2(ri, "margin-top", Nr(-1 * (v / 2 | 0)) + "px")
                    ])),
                    A4(Qi, n, t, P + ".p::before", d([
                        A2(ri, "content", "''"),
                        A2(ri, "display", "block"),
                        A2(ri, "height", "0"),
                        A2(ri, "width", "0"),
                        A2(ri, "margin-bottom", Nr(-1 * (v / 2 | 0)) + "px")
                    ]))
                ]));
            case 7:
                g = r.c;
                var j = r.d;
                return $ = r.e, A4(Qi, n, t, P = "." + (b = r.a), d([
                    A2(ri, "padding", ai(r.b) + "px " + ai(g) + "px " + ai(j) + "px " + ai($) + "px")
                ]));
            case 6:
                return g = r.c, j = r.d, $ = r.e, A4(Qi, n, t, P = "." + (b = r.a), d([
                    A2(ri, "border-width", Nr(r.b) + "px " + Nr(g) + "px " + Nr(j) + "px " + Nr($) + "px")
                ]));
            case 8:
                var K = r.a, A = F3(function(n, r, t) {
                    n: for(;;)switch(t.$){
                        case 0:
                            return Nr(t.a) + "px";
                        case 1:
                            var e = i(n, r);
                            if (1 === e.a.$) return 1 === e.b.$ ? "max-content" : "minmax(max-content, " + Nr(a = e.b.a) + "px)";
                            if (1 === e.b.$) return "minmax(" + Nr(e.a.a) + "px, max-content)";
                            var a = e.b.a;
                            return "minmax(" + Nr(e.a.a) + "px, " + Nr(a) + "px)";
                        case 2:
                            var u = t.a, c = i(n, r);
                            return 1 === c.a.$ ? 1 === c.b.$ ? Nr(u) + "fr" : "minmax(max-content, " + Nr(a = c.b.a) + "px)" : 1 === c.b.$ ? "minmax(" + Nr(c.a.a) + "px, " + Nr(u) + "frfr)" : (a = c.b.a, "minmax(" + Nr(c.a.a) + "px, " + Nr(a) + "px)");
                        case 3:
                            var o = t.b;
                            n = zr(t.a), t = o;
                            continue n;
                        default:
                            o = t.b, r = zr(t.a), t = o;
                            continue n;
                    }
                }), C = function(n) {
                    return A3(A, Sr, Sr, n);
                }, J = (C(K.dj.a), C(K.dj.b)), L = function(n) {
                    return "grid-template-rows: " + n + ";";
                }(A2(_r, " ", A2(St, C, K.c6))), z = function(n) {
                    return "-ms-grid-rows: " + n + ";";
                }(A2(_r, J, A2(St, C, K.D))), S = function(n) {
                    return "-ms-grid-columns: " + n + ";";
                }(A2(_r, J, A2(St, C, K.D))), N = "grid-row-gap:" + C(K.dj.b) + ";", _ = "grid-column-gap:" + C(K.dj.a) + ";", F = function(n) {
                    return "grid-template-columns: " + n + ";";
                }(A2(_r, " ", A2(St, C, K.D)));
                return d([
                    (P = ".grid-rows-" + A2(_r, "-", A2(St, Wu, K.c6)) + "-cols-" + A2(_r, "-", A2(St, Wu, K.D)) + "-space-x-" + Wu(K.dj.a) + "-space-y-" + Wu(K.dj.b)) + "{" + S + z + "}",
                    "@supports (display:grid) {" + P + "{" + F + L + _ + N + "}}"
                ]);
            case 9:
                var R = r.a, O = A2(_r, " ", d([
                    "-ms-grid-row: " + Nr(R.z) + ";",
                    "-ms-grid-row-span: " + Nr(R.be) + ";",
                    "-ms-grid-column: " + Nr(R.cm) + ";",
                    "-ms-grid-column-span: " + Nr(R.bR) + ";"
                ])), H = A2(_r, " ", d([
                    "grid-row: " + Nr(R.z) + " / " + Nr(R.z + R.be) + ";",
                    "grid-column: " + Nr(R.cm) + " / " + Nr(R.cm + R.bR) + ";"
                ]));
                return d([
                    (P = ".grid-pos-" + Nr(R.z) + "-" + Nr(R.cm) + "-" + Nr(R.bR) + "-" + Nr(R.be)) + "{" + O + "}",
                    "@supports (display:grid) {" + P + "{" + H + "}}"
                ]);
            case 11:
                var P = r.a;
                return A2(Ke, function(r) {
                    return A3(Di, n, r, zr(P));
                }, r.b);
            default:
                var T = r.a, E = function(n) {
                    switch(n.$){
                        case 0:
                            return Sr;
                        case 1:
                            var r = n.a, t = r.b, e = r.c;
                            return zr("translate3d(" + ai(r.a) + "px, " + ai(t) + "px, " + ai(e) + "px)");
                        default:
                            var a = n.a, u = a.b, i = a.c, c = n.b, o = c.a, f = c.b, s = c.c, b = n.c, l = b.a, d = b.b, v = b.c, h = n.d, p = "translate3d(" + ai(a.a) + "px, " + ai(u) + "px, " + ai(i) + "px)", g = "scale3d(" + ai(o) + ", " + ai(f) + ", " + ai(s) + ")", m = "rotate3d(" + ai(l) + ", " + ai(d) + ", " + ai(v) + ", " + ai(h) + "rad)";
                            return zr(p + " " + g + " " + m);
                    }
                }(T), I = i(P = qu(T), E);
                return I.a.$ || I.b.$ ? s : A4(Qi, n, t, "." + (b = I.a.a), d([
                    A2(ri, "transform", I.b.a)
                ]));
        }
    }), Wi = F2(function(n, r) {
        var t;
        return t = A2(St, function(r) {
            var t = A3(Di, n, r, Sr);
            return i(Zu(r), A2(Oi, Iu, t));
        }, r), A3(Rr, F2(function(n, r) {
            return A3(D, n.a, n.b, r);
        }), {}, t);
    }), Vi = F2(function(n, r) {
        return n + " {" + A2(_r, "", A2(St, function(n) {
            return n.a + ": " + n.b + ";";
        }, r)) + "}";
    }), qi = F3(function(n, r, t) {
        var e = t.b;
        return d([
            A2(Vi, "." + n + "." + r + ", ." + n + " ." + r, t.a),
            A2(Vi, "." + n + "." + r + "> ." + "t, ." + n + " ." + r + " > ." + ju, e)
        ]);
    }), Ui = F3(function(n, r, e) {
        var a = r.a, u = r.b, i = t(n, e) ? n : e + " ." + n;
        return A2(_r, " ", f(A3(qi, i, ku, u), A3(qi, i, "fs", a)));
    }), Zi = F2(function(n, r) {
        var e = t(n, r) ? n : r + " ." + n;
        return A2(_r, " ", d([
            A2(Vi, "." + e + "." + ku + ", ." + e + " ." + ku, d([
                i("line-height", "1")
            ])),
            A2(Vi, "." + e + "." + ku + "> ." + "t, ." + e + " ." + ku + " > ." + ju, d([
                i("vertical-align", "0"),
                i("line-height", "1")
            ]))
        ]));
    }), Gi = F3(function(n, r, t) {
        return {
            be: r / n,
            ad: n,
            bP: t
        };
    }), Xi = function(n) {
        return n.b ? zr(A3(Rr, $a, n.a, n.b)) : Sr;
    }, Yi = function(n) {
        var r, e = d([
            n.ch,
            n.b6,
            n.cq,
            n.cP
        ]), a = A2(Uu, n.cq, Xi(e)), u = A2(Uu, n.b6, Xi(A2(Ae, function(n) {
            return !t(n, a);
        }, e))), i = A2(Uu, n.ch, (r = e).b ? zr(A3(Rr, Gr, r.a, r.b)) : Sr), c = 1 / (i - a), o = 1 - i;
        return {
            ch: A3(Gi, 1 / (i - u), i - u, 1 - i),
            bc: A3(Gi, c, i - a, o)
        };
    }, nc = function(n) {
        return i(d([
            i("display", "block")
        ]), d([
            i("display", "inline-block"),
            i("line-height", ai(n.be)),
            i("vertical-align", ai(n.bP) + "em"),
            i("font-size", ai(n.ad) + "em")
        ]));
    }, rc = F2(function(n, r) {
        var t = A3(Rr, F2(function(r, t) {
            var e, a;
            return {
                aB: f(t.aB, A3(Di, n, r, Sr)),
                ao: (a = 1 === (e = r).$ ? zr(i(e.a, e.b)) : Sr, 1 === a.$ ? t.ao : A2(xr, a.a, t.ao))
            };
        }), {
            aB: s,
            ao: s
        }, r), e = t.aB;
        return f(function(n) {
            var r = function(n) {
                return 4 === n.$ ? zr("@import url('" + n.b + "');") : Sr;
            }, t = function(n) {
                return A2(_r, "\n", A2(ia, r, n.b));
            }, e = A2(St, rt, n), a = function(n) {
                var r, t = n.a, a = (r = n.b, A3(Rr, F2(function(n, r) {
                    if (1 === r.$) {
                        if (5 === n.$) {
                            var t = n.a.bW;
                            if (1 === t.$) return r;
                            var e = t.a;
                            return zr(i(nc(Yi(e).bc), nc(Yi(e).ch)));
                        }
                        return r;
                    }
                    return r;
                }), Sr, r));
                return A2(_r, "", A2(St, 1 === a.$ ? Zi(t) : A2(Ui, t, a.a), e));
            };
            return f(A2(_r, "\n", A2(St, t, n)), A2(_r, "\n", A2(St, a, n)));
        }(t.ao), zi(e));
    }), tc = F2(function(n, r) {
        switch(n.cR){
            case 0:
            case 1:
                return A3(bi, "div", s, d([
                    A3(bi, "style", s, d([
                        Fi(A2(rc, n, r))
                    ]))
                ]));
            default:
                return A3(bi, "elm-ui-rules", d([
                    A2(li, "rules", A2(Wi, n, r))
                ]), s);
        }
    }), ec = F4(function(n, r, t, e) {
        var a = A2(tc, r, A3(Rr, ni, i(Du, si(r.cy)), t).b);
        return n ? A2(xr, i("static-stylesheet", Ri(r)), A2(xr, i("dynamic-stylesheet", a), e)) : A2(xr, i("dynamic-stylesheet", a), e);
    }), ac = F4(function(n, r, t, e) {
        var a = A2(tc, r, A3(Rr, ni, i(Du, si(r.cy)), t).b);
        return n ? A2(xr, Ri(r), A2(xr, a, e)) : A2(xr, a, e);
    }), uc = Ha(45), ic = Ha(37), cc = function(n) {
        return Kn(Sn(n));
    }, oc = jn("p"), fc = F2(function(n, r) {
        var e = r.a;
        if (n.$) {
            var a = n.a;
            return t(a & r.b, a);
        }
        var u = n.a;
        return t(u & e, u);
    }), sc = jn("s"), bc = jn("u"), lc = Ha(44), dc = Ha(39), vc = F6(function(n, r, t, e, a, u) {
        var i = F2(function(n, r) {
            if (1 === e.$) {
                var t = e.a;
                return A3(cc, n, r, function() {
                    switch(a.$){
                        case 0:
                            return t;
                        case 2:
                            return A4(ec, !1, a.a, a.b, t);
                        default:
                            return A4(ec, !0, a.a, a.b, t);
                    }
                }());
            }
            var u = e.a;
            return A2(function() {
                switch(n){
                    case "div":
                        return Mu;
                    case "p":
                        return oc;
                    default:
                        return bi(n);
                }
            }(), r, function() {
                switch(a.$){
                    case 0:
                        return u;
                    case 2:
                        return A4(ac, !1, a.a, a.b, u);
                    default:
                        return A4(ac, !0, a.a, a.b, u);
                }
            }());
        }), c = function() {
            switch(r.$){
                case 0:
                    return A2(i, "div", t);
                case 1:
                    return A2(i, r.a, t);
                default:
                    return A3(bi, r.a, t, d([
                        A2(i, r.b, d([
                            Bu("s e")
                        ]))
                    ]));
            }
        }();
        switch(u){
            case 0:
                return A2(fc, dc, n) && !A2(fc, lc, n) ? c : A2(fc, Pu, n) ? A2(bc, d([
                    Bu(A2(_r, " ", d([
                        eu,
                        yu,
                        iu,
                        cu,
                        nu
                    ])))
                ]), d([
                    c
                ])) : A2(fc, Tu, n) ? A2(sc, d([
                    Bu(A2(_r, " ", d([
                        eu,
                        yu,
                        iu,
                        cu,
                        Xa
                    ])))
                ]), d([
                    c
                ])) : c;
            case 1:
                return A2(fc, ic, n) && !A2(fc, uc, n) ? c : A2(fc, Eu, n) ? A2(sc, d([
                    Bu(A2(_r, " ", d([
                        eu,
                        yu,
                        iu,
                        Ya
                    ])))
                ]), d([
                    c
                ])) : A2(fc, Hu, n) ? A2(bc, d([
                    Bu(A2(_r, " ", d([
                        eu,
                        yu,
                        iu,
                        Ga
                    ])))
                ]), d([
                    c
                ])) : c;
            default:
                return c;
        }
    }), hc = function(n) {
        return !n.b;
    }, pc = Fi, gc = function(n) {
        return A2(Mu, d([
            Bu("s t wc hc")
        ]), d([
            pc(n)
        ]));
    }, mc = function(n) {
        return A2(Mu, d([
            Bu("s t wf hf")
        ]), d([
            pc(n)
        ]));
    }, wc = F3(function(n, r, e) {
        var a = F2(function(r, e) {
            var a = r.a, u = r.b, c = e.a, o = e.b;
            switch(u.$){
                case 0:
                    var s = u.a;
                    return t(n, 4), i(A2(xr, i(a, s(n)), c), o);
                case 1:
                    var b = u.a;
                    return t(n, 4), i(A2(xr, i(a, A2(b.cD, Nu, n)), c), hc(o) ? b.$7 : f(b.$7, o));
                case 2:
                    var l = u.a;
                    return i(A2(xr, i(a, t(n, 2) ? mc(l) : gc(l)), c), o);
                default:
                    return i(c, o);
            }
        }), u = F2(function(r, e) {
            var a = e.a, u = e.b;
            switch(r.$){
                case 0:
                    var c = r.a;
                    return t(n, 4), i(A2(xr, c(n), a), u);
                case 1:
                    var o = r.a;
                    return t(n, 4), i(A2(xr, A2(o.cD, Nu, n), a), hc(u) ? o.$7 : f(o.$7, u));
                case 2:
                    var s = r.a;
                    return i(A2(xr, t(n, 2) ? mc(s) : gc(s), a), u);
                default:
                    return i(a, u);
            }
        });
        if (1 === r.$) {
            var c = r.a, o = A3(zt, a, i(s, s), c), b = o.a;
            if ((v = hc(d = o.b) ? e.$7 : f(e.$7, d)).b) {
                var l = v;
                return _u({
                    cD: A4(vc, e.T, e.U, e.P, Su(A3(Ou, "nearby-element-pls", b, e.Q))),
                    $7: l
                });
            }
            return Fu(A5(vc, e.T, e.U, e.P, Su(A3(Ou, "nearby-element-pls", b, e.Q)), Nu));
        }
        var d, v, h = r.a, p = A3(zt, u, i(s, s), h), g = p.a;
        return (v = hc(d = p.b) ? e.$7 : f(e.$7, d)).b ? (l = v, _u({
            cD: A4(vc, e.T, e.U, e.P, Wa(A2(Ru, g, e.Q))),
            $7: l
        })) : Fu(A5(vc, e.T, e.U, e.P, Wa(A2(Ru, g, e.Q)), Nu));
    }), $c = F3(function(n, r, t) {
        return {
            $: 3,
            a: n,
            b: r,
            c: t
        };
    }), xc = function(n) {
        return {
            $: 10,
            a: n
        };
    }, yc = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), kc = F2(function(n, r) {
        var t = r.a, e = r.b;
        return n.$ ? A2(yc, t, n.a | e) : A2(yc, n.a | t, e);
    }), jc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Kc = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Ac = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Cc = F2(function(n, r) {
        return A2(Mu, d([
            Bu(function() {
                switch(n){
                    case 0:
                        return A2(_r, " ", d([
                            hu,
                            yu,
                            "a"
                        ]));
                    case 1:
                        return A2(_r, " ", d([
                            hu,
                            yu,
                            "b"
                        ]));
                    case 2:
                        return A2(_r, " ", d([
                            hu,
                            yu,
                            gu
                        ]));
                    case 3:
                        return A2(_r, " ", d([
                            hu,
                            yu,
                            pu
                        ]));
                    case 4:
                        return A2(_r, " ", d([
                            hu,
                            yu,
                            vu
                        ]));
                    default:
                        return A2(_r, " ", d([
                            hu,
                            yu,
                            au
                        ]));
                }
            }())
        ]), d([
            function() {
                switch(r.$){
                    case 3:
                        return Fi("");
                    case 2:
                        return gc(r.a);
                    case 0:
                        return (0, r.a)(2);
                    default:
                        return A2(r.a.cD, Nu, 2);
                }
            }()
        ]));
    }), Jc = F3(function(n, r, t) {
        var e = A2(Cc, n, r);
        switch(t.$){
            case 0:
                return 5 === n ? jc(d([
                    e
                ])) : Ac(d([
                    e
                ]));
            case 1:
                var a = t.a;
                return 5 === n ? jc(A2(xr, e, a)) : A2(Kc, a, d([
                    e
                ]));
            case 2:
                var u = t.a;
                return 5 === n ? A2(Kc, d([
                    e
                ]), u) : Ac(A2(xr, e, u));
            default:
                return a = t.a, u = t.b, 5 === n ? A2(Kc, A2(xr, e, a), u) : A2(Kc, a, A2(xr, e, u));
        }
    }), Lc = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), zc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Sc = F2(function(n, r) {
        switch(r.$){
            case 0:
                return zc(n);
            case 1:
                return A2(Lc, r.a, n);
            default:
                return A2(Lc, r.a, r.b);
        }
    }), Nc = function(n) {
        switch(n){
            case 0:
                return "ah al";
            case 2:
                return "ah ar";
            default:
                return "ah cx";
        }
    }, _c = function(n) {
        switch(n){
            case 0:
                return "av at";
            case 2:
                return "av ab";
            default:
                return "av cy";
        }
    }, Fc = F2(function(n, r) {
        return A2(zn, function(n) {
            return /^(on|formAction$)/i.test(n) ? "data-" + n : n;
        }(n), Nn(r));
    }), Rc = F4(function(n, r, t, e) {
        return {
            $: 2,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Oc = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Hc = F2(function(n, r) {
        switch(n.$){
            case 0:
                switch(r.$){
                    case 0:
                        return Oc(c(a = r.a, 0, 0));
                    case 1:
                        return Oc(c(0, u = r.a, 0));
                    case 2:
                        return Oc(c(0, 0, i = r.a));
                    case 3:
                        return Oc(t = r.a);
                    case 4:
                        var t = r.a, e = r.b;
                        return A4(Rc, c(0, 0, 0), c(1, 1, 1), t, e);
                    default:
                        return t = r.a, A4(Rc, c(0, 0, 0), t, c(0, 0, 1), 0);
                }
            case 1:
                var a = (o = n.a).a, u = o.b, i = o.c;
                switch(r.$){
                    case 0:
                        return Oc(c(r.a, u, i));
                    case 1:
                        return Oc(c(a, r.a, i));
                    case 2:
                        return Oc(c(a, u, r.a));
                    case 3:
                        return Oc(t = r.a);
                    case 4:
                        return t = r.a, e = r.b, A4(Rc, o, c(1, 1, 1), t, e);
                    default:
                        return A4(Rc, o, r.a, c(0, 0, 1), 0);
                }
            default:
                a = (o = n.a).a, u = o.b, i = o.c;
                var o, f = n.b, s = n.c;
                switch(e = n.d, r.$){
                    case 0:
                        return A4(Rc, c(r.a, u, i), f, s, e);
                    case 1:
                        return A4(Rc, c(a, r.a, i), f, s, e);
                    case 2:
                        return A4(Rc, c(a, u, r.a), f, s, e);
                    case 3:
                        return A4(Rc, r.a, f, s, e);
                    case 4:
                        return A4(Rc, o, f, r.a, r.b);
                    default:
                        return A4(Rc, o, r.a, s, e);
                }
        }
    }), Pc = Ha(7), Tc = Ha(36), Ec = F2(function(n, r) {
        return A2(yc, n.a | r.a, n.b | r.b);
    }), Ic = A2(yc, 0, 0), Qc = function(n) {
        switch(n.$){
            case 0:
                var r = Nr(n.a), t = "height-px-" + r;
                return c(Ic, "he " + t, d([
                    A3($c, t, "height", r + "px")
                ]));
            case 1:
                return c(A2(kc, Tc, Ic), su, s);
            case 2:
                var e = n.a;
                return 1 === e ? c(A2(kc, ic, Ic), lu, s) : c(A2(kc, ic, Ic), du + " height-fill-" + Nr(e), d([
                    A3($c, "s.c > " + ei("height-fill-" + Nr(e)), "flex-grow", Nr(1e5 * e))
                ]));
            case 3:
                var a = n.a, u = n.b, i = "min-height-" + Nr(a), o = A3($c, i, "min-height", Nr(a) + "px !important"), f = Qc(u), b = f.b, l = f.c;
                return c(A2(kc, uc, f.a), i + " " + b, A2(xr, o, l));
            default:
                var v = n.a, h = (u = n.b, i = "max-height-" + Nr(v), o = A3($c, i, "max-height", Nr(v) + "px"), Qc(u));
                return b = h.b, l = h.c, c(A2(kc, uc, h.a), i + " " + b, A2(xr, o, l));
        }
    }, Bc = Ha(38), Mc = function(n) {
        switch(n.$){
            case 0:
                var r = n.a;
                return c(Ic, "we width-px-" + Nr(r), d([
                    A3($c, "width-px-" + Nr(r), "width", Nr(r) + "px")
                ]));
            case 1:
                return c(A2(kc, Bc, Ic), Au, s);
            case 2:
                var t = n.a;
                return 1 === t ? c(A2(kc, dc, Ic), Ju, s) : c(A2(kc, dc, Ic), Lu + " width-fill-" + Nr(t), d([
                    A3($c, "s.r > " + ei("width-fill-" + Nr(t)), "flex-grow", Nr(1e5 * t))
                ]));
            case 3:
                var e = n.a, a = n.b, u = "min-width-" + Nr(e), i = A3($c, u, "min-width", Nr(e) + "px"), o = Mc(a), f = o.b, b = o.c;
                return c(A2(kc, lc, o.a), u + " " + f, A2(xr, i, b));
            default:
                var l = n.a, v = (a = n.b, u = "max-width-" + Nr(l), i = A3($c, u, "max-width", Nr(l) + "px"), Mc(a));
                return f = v.b, b = v.c, c(A2(kc, lc, v.a), u + " " + f, A2(xr, i, b));
        }
    }, Dc = Ha(27), Wc = F2(function(n, r) {
        if (t(n, Dc)) {
            if (3 !== r.$) return !1;
            switch(r.c){
                case "0px":
                case "1px":
                case "2px":
                case "3px":
                case "4px":
                case "5px":
                case "6px":
                    return !0;
                default:
                    return !1;
            }
        } else switch(r.$){
            case 2:
                var e = r.a;
                return e >= 8 && 32 >= e;
            case 7:
                var a = r.b, u = r.c, i = r.e;
                return t(a, r.d) && t(a, u) && t(a, i) && a >= 0 && 24 >= a;
            default:
                return !1;
        }
    }), Vc = Ha(6), qc = Ha(30), Uc = Ha(29), Zc = F8(function(n, r, t, e, a, u, i, c) {
        n: for(;;){
            if (!c.b) {
                var o = qu(e);
                return 1 === o.$ ? {
                    P: A2(xr, Bu(n), u),
                    Q: i,
                    T: t,
                    U: r,
                    $7: a
                } : {
                    P: A2(xr, Bu(n + " " + o.a), u),
                    Q: i,
                    T: t,
                    U: r,
                    $7: A2(xr, xc(e), a)
                };
            }
            var s = c.a, b = c.b;
            switch(s.$){
                case 0:
                    n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                    continue n;
                case 3:
                    var l = s.b;
                    if (A2(fc, v = s.a, t)) {
                        n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                        continue n;
                    }
                    n = g = l + " " + n, r = m = r, t = w = A2(kc, v, t), e = $ = e, a = x = a, c = b;
                    continue n;
                case 1:
                    n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, u = A2(xr, s.a, u), c = b;
                    continue n;
                case 4:
                    var d = s.b;
                    if (A2(fc, v = s.a, t)) {
                        n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                        continue n;
                    }
                    if (A2(Wc, v, d)) {
                        n = g = Zu(d) + " " + n, r = m = r, t = w = A2(kc, v, t), e = $ = e, a = x = a, c = b;
                        continue n;
                    }
                    n = g = Zu(d) + " " + n, r = m = r, t = w = A2(kc, v, t), e = $ = e, a = x = A2(xr, d, a), c = b;
                    continue n;
                case 10:
                    var v, h = s.b;
                    n = g = n, r = m = r, t = w = A2(kc, v = s.a, t), e = $ = A2(Hc, e, h), a = x = a, c = b;
                    continue n;
                case 7:
                    var p = s.a;
                    if (A2(fc, Vc, t)) {
                        n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                        continue n;
                    }
                    switch(p.$){
                        case 0:
                            var g = "we width-px-" + Nr(K = p.a) + " " + n, m = r, w = A2(kc, Vc, t), $ = e, x = A2(xr, A3($c, "width-px-" + Nr(K), "width", Nr(K) + "px"), a);
                            n = g, r = m, t = w, e = $, a = x, c = b;
                            continue n;
                        case 1:
                            n = g = n + " " + Au, r = m = r, t = w = A2(kc, Bc, A2(kc, Vc, t)), e = $ = e, a = x = a, c = b;
                            continue n;
                        case 2:
                            if (1 === (J = p.a)) {
                                n = g = n + " " + Ju, r = m = r, t = w = A2(kc, dc, A2(kc, Vc, t)), e = $ = e, a = x = a, c = b;
                                continue n;
                            }
                            g = n + " " + Lu + " width-fill-" + Nr(J), m = r, w = A2(kc, dc, A2(kc, Vc, t)), $ = e, x = A2(xr, A3($c, "s.r > " + ei("width-fill-" + Nr(J)), "flex-grow", Nr(1e5 * J)), a), n = g, r = m, t = w, e = $, a = x, c = b;
                            continue n;
                        default:
                            var y = Mc(p), k = y.c;
                            g = n + " " + y.b, m = r, w = A2(Ec, y.a, A2(kc, Vc, t)), $ = e, x = f(k, a), n = g, r = m, t = w, e = $, a = x, c = b;
                            continue n;
                    }
                case 8:
                    var j = s.a;
                    if (A2(fc, Pc, t)) {
                        n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                        continue n;
                    }
                    switch(j.$){
                        case 0:
                            var K, A = Nr(K = j.a) + "px", C = "height-px-" + A;
                            n = g = "he " + C + " " + n, r = m = r, t = w = A2(kc, Pc, t), e = $ = e, a = x = A2(xr, A3($c, C, "height ", A), a), c = b;
                            continue n;
                        case 1:
                            n = g = "hc " + n, r = m = r, t = w = A2(kc, Tc, A2(kc, Pc, t)), e = $ = e, a = x = a, c = b;
                            continue n;
                        case 2:
                            var J;
                            if (1 === (J = j.a)) {
                                n = g = "hf " + n, r = m = r, t = w = A2(kc, ic, A2(kc, Pc, t)), e = $ = e, a = x = a, c = b;
                                continue n;
                            }
                            g = n + " " + du + " height-fill-" + Nr(J), m = r, w = A2(kc, ic, A2(kc, Pc, t)), $ = e, x = A2(xr, A3($c, "s.c > " + ei("height-fill-" + Nr(J)), "flex-grow", Nr(1e5 * J)), a), n = g, r = m, t = w, e = $, a = x, c = b;
                            continue n;
                        default:
                            var L = Qc(j);
                            k = L.c, g = n + " " + L.b, m = r, w = A2(Ec, L.a, A2(kc, Pc, t)), $ = e, x = f(k, a), n = g, r = m, t = w, e = $, a = x, c = b;
                            continue n;
                    }
                case 2:
                    var z = s.a;
                    switch(z.$){
                        case 0:
                            n = g = n, r = m = A2(Sc, "main", r), t = w = t, e = $ = e, a = x = a, c = b;
                            continue n;
                        case 1:
                            n = g = n, r = m = A2(Sc, "nav", r), t = w = t, e = $ = e, a = x = a, c = b;
                            continue n;
                        case 2:
                            n = g = n, r = m = A2(Sc, "footer", r), t = w = t, e = $ = e, a = x = a, c = b;
                            continue n;
                        case 3:
                            n = g = n, r = m = A2(Sc, "aside", r), t = w = t, e = $ = e, a = x = a, c = b;
                            continue n;
                        case 4:
                            var S = z.a;
                            if (S > 1) {
                                if (7 > S) {
                                    n = g = n, r = m = A2(Sc, "h" + Nr(S), r), t = w = t, e = $ = e, a = x = a, c = b;
                                    continue n;
                                }
                                n = g = n, r = m = A2(Sc, "h6", r), t = w = t, e = $ = e, a = x = a, c = b;
                                continue n;
                            }
                            n = g = n, r = m = A2(Sc, "h1", r), t = w = t, e = $ = e, a = x = a, c = b;
                            continue n;
                        case 9:
                            n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                            continue n;
                        case 8:
                            n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, u = A2(xr, A2(Fc, "role", "button"), u), c = b;
                            continue n;
                        case 5:
                            n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, u = A2(xr, A2(Fc, "aria-label", z.a), u), c = b;
                            continue n;
                        case 6:
                            n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, u = A2(xr, A2(Fc, "aria-live", "polite"), u), c = b;
                            continue n;
                        default:
                            n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, u = A2(xr, A2(Fc, "aria-live", "assertive"), u), c = b;
                            continue n;
                    }
                case 9:
                    var N = s.a, _ = s.b;
                    k = function() {
                        switch(_.$){
                            case 3:
                            case 2:
                            case 0:
                                return a;
                            default:
                                return f(a, _.a.$7);
                        }
                    }(), n = g = n, r = m = r, t = w = t, e = $ = e, a = x = k, i = A3(Jc, N, _, i), c = b;
                    continue n;
                case 6:
                    var F = s.a;
                    if (A2(fc, qc, t)) {
                        n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                        continue n;
                    }
                    n = g = Nc(F) + " " + n, r = m = r, t = w = function(n) {
                        switch(F){
                            case 1:
                                return A2(kc, Tu, n);
                            case 2:
                                return A2(kc, Pu, n);
                            default:
                                return n;
                        }
                    }(A2(kc, qc, t)), e = $ = e, a = x = a, c = b;
                    continue n;
                default:
                    var R = s.a;
                    if (A2(fc, Uc, t)) {
                        n = g = n, r = m = r, t = w = t, e = $ = e, a = x = a, c = b;
                        continue n;
                    }
                    n = g = _c(R) + " " + n, r = m = r, t = w = function(n) {
                        switch(R){
                            case 1:
                                return A2(kc, Eu, n);
                            case 2:
                                return A2(kc, Hu, n);
                            default:
                                return n;
                        }
                    }(A2(kc, Uc, t)), e = $ = e, a = x = a, c = b;
                    continue n;
            }
        }
    }), Gc = {
        $: 0
    }, Xc = Gc, Yc = F4(function(n, r, t, e) {
        return A3(wc, n, e, A8(Zc, function(n) {
            switch(n){
                case 0:
                    return "s r";
                case 1:
                    return "s c";
                case 2:
                    return "s e";
                case 3:
                    return "s g";
                case 4:
                    return "s p";
                default:
                    return "s pg";
            }
        }(n), r, Ic, Xc, s, s, qa, Pr(t)));
    }), no = function(n) {
        return {
            $: 8,
            a: n
        };
    }, ro = no, to = {
        $: 1
    }, eo = function(n) {
        return {
            $: 7,
            a: n
        };
    }, ao = eo, uo = F2(function(n, r) {
        return A4(Yc, 2, Va, A2(xr, ao(to), A2(xr, ro(to), n)), Wa(d([
            r
        ])));
    }), io = F3(function(n, r, t) {
        return {
            $: 4,
            a: n,
            b: r,
            c: t
        };
    }), co = Ha(14), oo = function(n) {
        var r = n.b, t = n.c, e = n.d;
        return Vu(n.a) + "-" + Vu(r) + "-" + Vu(t) + "-" + Vu(e);
    }, fo = function(n) {
        return A2(Oa, co, A3(io, "fc-" + oo(n), "color", n));
    }, so = function(n) {
        return {
            $: 1,
            a: n
        };
    }, bo = so, lo = F2(function(n, r) {
        return {
            $: 11,
            a: n,
            b: r
        };
    }), vo = Ha(33), ho = function(n) {
        return {
            $: 5,
            a: n
        };
    }, po = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), go = function(n) {
        return {
            $: 2,
            a: n
        };
    }, mo = F2(function(n, r) {
        return {
            $: 9,
            a: n,
            b: r
        };
    }), wo = {
        $: 0
    }, $o = F2(function(n, r) {
        return {
            $: 10,
            a: n,
            b: r
        };
    }), xo = {
        $: 3
    }, yo = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ko = F3(function(n, r, t) {
        return n(r(t));
    }), jo = An, Ko = F2(function(n, r) {
        switch(r.$){
            case 1:
                var t = r.a;
                return _u({
                    cD: F2(function(r, e) {
                        return A2(jo, n, A2(t.cD, r, e));
                    }),
                    $7: t.$7
                });
            case 0:
                var e = r.a;
                return Fu(A2(ko, jo(n), e));
            case 2:
                return yo(r.a);
            default:
                return xo;
        }
    }), Ao = Fn, Co = F2(function(n, r) {
        switch(r.$){
            case 0:
                return wo;
            case 2:
                return go(r.a);
            case 6:
                return Ma(r.a);
            case 5:
                return ho(r.a);
            case 7:
                return eo(r.a);
            case 8:
                return no(r.a);
            case 3:
                return A2(po, r.a, r.b);
            case 4:
                return A2(Oa, r.a, r.b);
            case 9:
                return A2(mo, r.a, A2(Ko, n, r.b));
            case 1:
                return so(A2(Ao, n, r.a));
            default:
                return A2($o, r.a, r.b);
        }
    }), Jo = F2(function(n, r) {
        var t = r.a, e = r.b, a = A2(Co, At, n);
        switch(a.$){
            case 4:
                return i(A2(xr, a.b, t), e);
            case 10:
                return i(t, A2(Hc, e, a.b));
            default:
                return i(t, e);
        }
    }), Lo = function(n) {
        var r, t, e;
        return A2(Oa, vo, A2(lo, 1, (r = n, e = (t = A3(Rr, Jo, i(s, Gc), r)).a, A2(xr, xc(t.b), e))));
    }, zo = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), So = F3(function(n, r, t) {
        return A4(zo, n / 255, r / 255, t / 255, 1);
    }), No = function(n) {
        var r = d([
            bo(Bu("underlineAnimation")),
            Lo(d([
                fo(A3(So, 236, 56, 107))
            ]))
        ]);
        return 0 === n ? s : r;
    }, _o = Cn, Fo = F2(function(n, r) {
        return A2(_o, n, {
            $: 0,
            a: r
        });
    }), Ro = function(n) {
        return A2(Fo, "click", ft(n));
    }, Oo = A2(ko, so, Ro), Ho = F5(function(n, r, t, e, a) {
        return {
            $: 7,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), Po = Ha(2), To = function(n) {
        var r = n;
        return A2(Oa, Po, A5(Ho, "p-" + Nr(n), r, r, r, r));
    }, Eo = Ha(21), Io = A2(po, Eo, fu), Qo = function(n) {
        return yo(n);
    }, Bo = function(n) {
        return A2(uo, f(d([
            Da,
            To(10),
            Io,
            Oo(Qa)
        ]), No(n.aK.aJ)), Qo(Ba(n.bm)));
    }, Mo = {
        $: 9
    }, Do = {
        $: 10
    }, Wo = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Vo = Ha(4), qo = function(n) {
        return A2(Oa, Vo, Wo(n));
    }, Uo = function(n) {
        return A2(uo, d([
            Io,
            To(10),
            qo(12),
            Oo(1 === n.bm ? Mo : Do)
        ]), Qo(n.bm ? "English" : "\u65E5\u672C\u8A9E"));
    }, Zo = Ha(13), Go = A2(po, Zo, "w7"), Xo = Ha(28), Yo = function(n) {
        return A2(Oa, Xo, A3(io, "bc-" + oo(n), "border-color", n));
    }, nf = function(n) {
        return {
            $: 2,
            a: n
        };
    }, rf = nf(1), tf = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ef = function(n) {
        return ro(tf(n.bN ? 80 : 100));
    }, af = Qu("id"), uf = F2(function(n, r) {
        if (t(n, r)) {
            var e = n;
            return A2(Oa, Po, A5(Ho, "p-" + Nr(n), e, e, e, e));
        }
        var a = r, u = n;
        return A2(Oa, Po, A5(Ho, "p-" + Nr(n) + "-" + Nr(r), a, u, a, u));
    }), cf = F5(function(n, r, t, e, a) {
        return {
            $: 6,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), of = function(n) {
        return A2(Oa, Dc, A5(cf, "b-" + Nr(n), n, n, n, n));
    }, ff = F2(function(n, r) {
        return A2(Oa, Dc, A5(cf, "b-" + Nr(n) + "-" + Nr(r), r, n, r, n));
    }), sf = Ha(8), bf = Ha(10), lf = function(n) {
        var r = n.a2, t = n.bI;
        if (t.b) {
            if (t.b.b) return A2(Oa, bf, A3($c, "bg-grad-" + A2(_r, "-", A2(xr, Vu(r), A2(St, oo, t))), "background-image", "linear-gradient(" + A2(_r, ", ", A2(xr, ai(r) + "rad", A2(St, ui, t))) + ")"));
            var e = t.a;
            return A2(Oa, sf, A3(io, "bg-" + oo(e), "background-color", e));
        }
        return wo;
    }, df = zo, vf = d([
        lf({
            a2: 3.14,
            bI: d([
                A4(df, 1, 1, 1, 1),
                A4(df, 1, 1, 1, 0)
            ])
        })
    ]), hf = Ha(19), pf = F2(function(n, r) {
        var t, e, a;
        return t = {
            _: 2 * r,
            aa: n,
            bs: i(0, 0),
            ad: r
        }, A2(Oa, hf, A3($c, zi(d([
            (e = a = {
                _: t._,
                aa: t.aa,
                bj: !1,
                bs: t.bs,
                ad: t.ad
            }).bj ? "box-inset" : "box-",
            Vu(e.bs.a) + "px",
            Vu(e.bs.b) + "px",
            Vu(e._) + "px",
            Vu(e.ad) + "px",
            oo(e.aa)
        ])), "box-shadow", ii(a)));
    }), gf = F4(function(n, r, t, e) {
        return A4(zo, n / 255, r / 255, t / 255, e);
    }), mf = d([
        A2(pf, A4(gf, 0, 0, 0, .05), 2),
        lf({
            a2: 3.14,
            bI: d([
                A4(df, 1, 1, 1, 1),
                A4(df, 1, 1, 1, 1)
            ])
        })
    ]), wf = {
        $: 4
    }, $f = {
        $: 3
    }, xf = F2(function(n, r) {
        return 3 === r.$ ? wo : A2(mo, n, r);
    }), yf = function(n) {
        return A2(xf, 5, n);
    }, kf = function(n) {
        return A2(xf, 4, n);
    }, jf = {
        $: 5
    }, Kf = Qu("alt"), Af = function(n) {
        return so(Bu(n));
    }, Cf = F2(function(n, r) {
        var t, e = r.dl, a = r.cr, u = A2(Ae, function(n) {
            switch(n.$){
                case 7:
                case 8:
                    return !0;
                default:
                    return !1;
            }
        }, n);
        return A4(Yc, 2, Va, A2(xr, Af("ic"), n), Wa(d([
            A4(Yc, 2, zc("img"), f(d([
                so((t = e, A2(Qu, "src", Nn(t)))),
                so(Kf(a))
            ]), u), Wa(s))
        ])));
    }), Jf = {
        cr: "logo",
        dl: "images/logo/logo.svg"
    }, Lf = A2(Cf, d([
        ao(tf(50)),
        ro(tf(50)),
        Oo(jf)
    ]), Jf), zf = {
        cr: "logo",
        dl: "images/logo/logoWithShadow.svg"
    }, Sf = F2(function(n, r) {
        return {
            $: 12,
            a: n,
            b: r
        };
    }), Nf = Ha(0), _f = function(n) {
        return A2(Oa, Nf, n ? A2(Sf, "transparent", 1) : A2(Sf, "visible", 0));
    }, Ff = function(n) {
        return A2(Cf, d([
            bo(af("stickyHeader")),
            bo(Bu("animatedTransition")),
            ao(tf(50)),
            ro(tf(50)),
            _f(!n.cT)
        ]), zf);
    }, Rf = function(n) {
        return A2(Fo, "mouseout", ft(n));
    }, Of = function(n) {
        return A2(Fo, "mouseover", ft(n));
    }, Hf = xo, Pf = function(n) {
        return A2(uo, f(d([
            ao(tf(50)),
            ro(tf(50)),
            Io
        ]), function(n) {
            var r = d([
                kf(Lf)
            ]), t = d([
                kf(Lf),
                yf(Ff(n)),
                bo(Of($f)),
                bo(Rf(wf))
            ]);
            return 0 === n.aK.aJ ? r : t;
        }(n)), Hf);
    }, Tf = F2(function(n, r) {
        return A4(Yc, 0, Va, A2(xr, Af("cl " + cu), A2(xr, ao(to), A2(xr, ro(to), n))), Wa(r));
    }), Ef = {
        $: 8
    }, If = function(n) {
        return n ? "\u30B5\u30DD\u30FC\u30C8" : "Support";
    }, Qf = function(n) {
        return A2(uo, f(d([
            Da,
            To(10),
            Io,
            Oo(Ef)
        ]), No(n.aK.aJ)), Qo(If(n.bm)));
    }, Bf = function(n) {
        return A2(Tf, function(n) {
            return A2(ke, function(n) {
                var r;
                return d([
                    Go,
                    A2(uf, 20, 0),
                    ao(rf),
                    ef(n),
                    bo(Bu("animatedTransition")),
                    bo(af("stickyHeader")),
                    (r = 10, t(r, 0) && t(0, 0) ? t(r, 0) ? of(r) : A2(ff, 0, r) : A2(Oa, Dc, A5(cf, "b-" + Nr(r) + "-" + Nr(0) + "-" + Nr(0) + "-" + Nr(0), r, 0, 0, 0))),
                    Yo(A3(So, 181, 111, 241))
                ]);
            }(n), n.bN ? mf : vf);
        }(n), d([
            Pf(n),
            Bo(n),
            Qf(n),
            Uo(n)
        ]));
    }, Mf = function(n) {
        return {
            $: 16,
            a: n
        };
    }, Df = Ma(1), Wf = ho(1), Vf = function(n) {
        return A2(Oa, sf, A3(io, "bg-" + oo(n), "background-color", n));
    }, qf = function(n) {
        var r = xa(n.bQ.bQ.bR), t = xa(n.bQ.bQ.be);
        return a(t, xa(1.775 * n.bQ.bQ.bR)) > 0 ? ao(tf(r - 70)) : ro(tf(t - 70));
    }, Uf = bo(Bu("shadow")), Zf = F2(function(n) {
        return n;
    }), Gf = A2(ko, Fu, Zf), Xf = Gf, Yf = bi, ns = Xf(A3(Yf, "style", s, d([
        pc("body { overflow: hidden; } ")
    ]))), rs = function(n) {
        return A2(Tf, d([
            ao(rf),
            ro(rf),
            Vf(A4(gf, 0, 0, 0, .35)),
            Oo(Mf(n.c8))
        ]), d([
            A2(Cf, d([
                Io,
                Df,
                Wf,
                qf(n),
                Uf
            ]), {
                cr: n.c8,
                dl: "/images/screenshots/" + n.c8
            }),
            ns
        ]));
    }, ts = function(n) {
        return {
            $: 3,
            a: n
        };
    }, es = ts, as = function(n) {
        var r;
        return f(d([
            (r = d([
                es("Josefin Sans")
            ]), A2(Oa, Pa, A2(Ra, A3(Rr, Ia, "ff-", r), r))),
            kf(Bf(n))
        ]), n.df ? d([
            kf(rs(n))
        ]) : s);
    }, us = F2(function(n, r) {
        return A4(Yc, 1, Va, A2(xr, Af("ct cl"), A2(xr, ro(to), A2(xr, ao(to), n))), Wa(r));
    }), is = d([
        bo(af(za)),
        bo(Bu("fullViewportHeight")),
        ao(rf)
    ]), cs = function(n) {
        return n ? "\u304B\u306A\u30D1\u30FC\u30C6\u30A3\u30FC" : "Kana Party";
    }, os = function(n) {
        return n ? "\u79C1\u306F\u30A2\u30EC\u30AF\u30B5\u30F3\u30C0\u30FC\u30FB\u30AA\u30EB\u30C6\u30A3\u30F3\u30B9\u30AD\u30FC\u3067\u3059\u3002\u5B66\u751F\u304C\u9762\u767D\u3044\u65B9\u6CD5\u3067\u65E5\u672C\u8A9E\u3092\u5B66\u3076\u305F\u3081\u306B" + cs(n) + "\u3092\u4F5C\u308A\u307E\u3057\u305F\u3002" : "My name is Aleksander Ortynski and I created " + cs(n) + " so that students could have a more engaging way to learn Japanese.";
    }, fs = function(n) {
        return n ? "\u79C1\u306F\u30C6\u30AD\u30B5\u30B9\u5DDE\u30AA\u30FC\u30B9\u30C6\u30A3\u30F3\u3092\u62E0\u70B9\u306B\u3059\u308B\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A\u8005\u3067\u3042\u308A\u300110\u5E74\u4EE5\u4E0A\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u3092\u69CB\u7BC9\u3057\u3066\u304D\u307E\u3057\u305F\u3002" : "I'm a software developer based in Austin TX and have been building software solutions for over 10 years.";
    }, ss = function(n) {
        return n ? "\u79C1\u306F\u6700\u8FD1\u95A2\u6570\u578B\u30D7\u30ED\u30B0\u30E9\u30DF\u30F3\u30B0\u306B\u8208\u5473\u3092\u6301\u3063\u3066\u3044\u308B\u306E\u3067\u3001\u3053\u306E\u30A6\u30A8\u30D6\u30B5\u30A4\u30C8\u306F\u30A8\u30EB\u30E0\u3067\u958B\u767A\u3057\u307E\u3057\u305F\u3002" : "I developed this website in Elm because I have recently taken a strong interest in functional programming.";
    }, bs = Ha(12), ls = A2(po, bs, "tc"), ds = "ortynski@gmail.com", vs = function(n) {
        return n ? "\u304A\u554F\u5408\u305B\uFF1A" : "Contact me:";
    }, hs = zn("rel"), ps = F2(function(n, r) {
        var t = r.dI, e = r.cO;
        return A4(Yc, 2, zc("a"), A2(xr, so(function(n) {
            var r;
            return A2(Qu, "href", /^javascript:/i.test((r = n).replace(/\s/g, "")) ? "" : r);
        }(t)), A2(xr, so(hs("noopener noreferrer")), A2(xr, ao(to), A2(xr, ro(to), A2(xr, Af("ccx ccy lnk"), n))))), Wa(d([
            e
        ])));
    }), gs = Xf(A2(jn("br"), s, s)), ms = {
        $: 9
    }, ws = F3(function(n, r, t) {
        return {
            $: 5,
            a: n,
            b: r,
            c: t
        };
    }), $s = Ha(3), xs = F2(function(n, r) {
        return "spacing-" + Nr(n) + "-" + Nr(r);
    }), ys = F2(function(n, r) {
        return A4(Yc, 4, Va, A2(xr, go(ms), A2(xr, ao(rf), A2(xr, A2(Oa, $s, A3(ws, A2(xs, 5, 5), 5, 5)), n))), Wa(r));
    }), ks = Ha(17), js = function(n) {
        return A2(Oa, ks, A3($c, "br-" + Nr(n), "border-radius", Nr(n) + "px"));
    }, Ks = function(n) {
        return A2(Tf, d([
            ao(rf),
            A2(uf, 30, 30),
            js(10),
            Vf(A3(So, 255, 255, 255)),
            Uf
        ]), d([
            A2(ys, d([
                ls
            ]), d([
                Qo(os(n)),
                Qo(fs(n)),
                Qo(ss(n)),
                gs,
                gs,
                Qo(vs(n)),
                gs,
                A2(ps, d([
                    fo(A3(So, 6, 69, 173))
                ]), {
                    cO: Qo(ds),
                    dI: "mailto: " + ds
                })
            ]))
        ]));
    }, As = ho(0), Cs = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Js = F2(function(n, r) {
        return A2(Cs, n, r);
    }), Ls = Ha(20), zs = A2(po, Ls, "cp"), Ss = {
        cr: "",
        dl: "/images/portraits/portraitSmall.png"
    }, Ns = function(n) {
        var r;
        return A2(Tf, d([
            Df,
            A2(uf, 60, 30)
        ]), d([
            A2(Cf, d([
                js(30),
                zs,
                (r = n.aK.aJ, ro(tf(r && 1 !== r ? 243 : 162))),
                Df,
                Uf
            ]), Ss)
        ]));
    }, _s = function(n) {
        switch(n.aK.aJ){
            case 0:
            case 1:
                return function(n) {
                    return A2(us, d([
                        As,
                        Df,
                        Wf,
                        ao(A2(Js, 420, rf))
                    ]), d([
                        Ns(n),
                        Ks(n.bm)
                    ]));
                }(n);
            default:
                return function(n) {
                    return A2(Tf, d([
                        As,
                        Df,
                        Wf,
                        ao(A2(Js, 1e3, rf))
                    ]), d([
                        Ns(n),
                        Ks(n.bm)
                    ]));
                }(n);
        }
    }, Fs = "/images/background/backgroundNoLogo.svg", Rs = function(n) {
        switch(n){
            case 0:
                return qo(19);
            case 1:
                return qo(22);
            case 2:
                return qo(23);
            default:
                return qo(24);
        }
    }, Os = A2(ko, go, function(n) {
        return {
            $: 4,
            a: n
        };
    }), Hs = Jn, Ps = function(n) {
        return so(A2(Hs, "background", 'url("' + n + '") center / cover no-repeat'));
    }, Ts = function(n) {
        return A2(Tf, d([
            ao(rf),
            bo(Bu("fullViewportHeight")),
            Df,
            Os(1),
            Rs(n.aK.aJ),
            Ps(Fs)
        ]), d([
            A2(us, d([
                Df,
                ro(rf),
                ao(rf),
                A2(uf, 40, 40)
            ]), d([
                _s(n)
            ]))
        ]));
    }, Es = function(n) {
        return "\xa9" + Nr(n) + " Aleksander Ortynski.  All Rights Reserved.";
    }, Is = F4(function(n, r, t, e) {
        return "pad-" + Nr(n) + "-" + Nr(r) + "-" + Nr(t) + "-" + Nr(e);
    }), Qs = function(n) {
        var r = n.bL, e = n.bF, a = n.a3, u = n.bn;
        if (t(r, e) && t(r, a) && t(r, u)) {
            var i = r;
            return A2(Oa, Po, A5(Ho, "p-" + Nr(r), i, i, i, i));
        }
        return A2(Oa, Po, A5(Ho, A4(Is, r, e, a, u), r, e, a, u));
    }, Bs = {
        $: 7
    }, Ms = function(n) {
        switch(n){
            case 0:
                return qo(13);
            case 1:
                return qo(18);
            default:
                return qo(20);
        }
    }, Ds = F3(function(n, r, t) {
        var e;
        return A2(us, f(d([
            (e = n.aK.aJ, To(0 === e ? 6 : 10)),
            Io,
            Oo(t),
            Ms(n.aK.aJ)
        ]), function(n) {
            var r = d([
                bo(Bu("underlineAnimation")),
                Lo(d([
                    fo(A3(So, 236, 56, 107))
                ]))
            ]);
            return 0 === n ? s : r;
        }(n.aK.aJ)), d([
            Qo(r)
        ]));
    }), Ws = A2(us, d([
        To(20)
    ]), d([
        A2(Cf, d([
            ao(tf(50)),
            ro(tf(50)),
            Io,
            Oo(jf)
        ]), {
            cr: "logo",
            dl: "images/logo/logo.svg"
        })
    ])), Vs = function(n) {
        return n ? "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC" : "Privacy Policy";
    }, qs = function(n) {
        return A2(Tf, d([
            ao(rf)
        ]), d([
            Ws,
            A3(Ds, n, Ba(n.bm), Qa),
            A3(Ds, n, If(n.bm), Ef),
            A3(Ds, n, Vs(n.bm), Bs)
        ]));
    }, Us = function(n) {
        var r;
        return A2(us, d([
            Df,
            Wf,
            ao(rf)
        ]), d([
            A2(us, d([
                Df,
                ao(rf),
                Vf(A3(So, 26, 44, 58)),
                fo(A3(So, 255, 255, 255)),
                ls,
                A2(uf, 0, 5)
            ]), d([
                qs(n),
                (r = n.dP, A2(Tf, d([
                    qo(15),
                    Qs({
                        a3: 0,
                        bn: 20,
                        bF: 0,
                        bL: 20
                    })
                ]), d([
                    Qo(Es(r))
                ])))
            ]))
        ]));
    }, Zs = {
        $: 2
    }, Gs = {
        $: 1
    }, Xs = F2(function(n, r) {
        return A2(Cf, d([
            ao(tf(270)),
            ro(tf(110)),
            Df,
            Qs({
                a3: 0,
                bn: 10,
                bF: 0,
                bL: 0
            }),
            _f(!n.cS),
            bo(Bu("animatedTransition"))
        ]), r);
    }), Ys = Qu("target"), nb = F2(function(n, r) {
        return A2(ps, d([
            bo(Ys("_blank"))
        ]), {
            cO: r,
            dI: n
        });
    }), rb = {
        cr: "Play Now Button",
        dl: "images/play-now.svg"
    }, tb = function(n) {
        return A2(nb, "https://play.kanaparty.com", A2(Xs, n, rb));
    }, eb = {
        cr: "Play Now Button",
        dl: "images/play-now-no-shadow.svg"
    }, ab = function(n) {
        var r;
        return A2(uo, d([
            ao(tf(270)),
            ro(tf(110)),
            Io,
            Df,
            kf(A2(nb, "https://play.kanaparty.com", (r = eb, A2(Cf, d([
                ao(tf(270)),
                ro(tf(110)),
                Df,
                Qs({
                    a3: 0,
                    bn: 10,
                    bF: 0,
                    bL: 0
                })
            ]), r)))),
            yf(tb(n)),
            bo(Of(Gs)),
            bo(Rf(Zs))
        ]), Hf);
    }, ub = function(n) {
        switch(n){
            case 0:
                return qo(35);
            case 1:
                return qo(55);
            case 2:
                return qo(65);
            default:
                return qo(82);
        }
    }, ib = function(n) {
        return A2(Tf, d([
            ao(rf),
            Df,
            Qs({
                a3: 40,
                bn: 0,
                bF: 0,
                bL: 60
            }),
            Os(1),
            Go,
            ub(n.aK.aJ)
        ]), d([
            A2(us, d([
                Df
            ]), d([
                Qo(cs(n.bm))
            ]))
        ]));
    }, cb = A2(uo, d([
        ao(rf),
        zs,
        bo(Bu("fullViewportHeight")),
        Ps("/images/background/background.svg")
    ]), Hf), ob = function(n) {
        return A2(us, d([
            To(20),
            ao(rf),
            ro(rf)
        ]), d([
            A2(Cf, d([
                ao(rf),
                ro(rf),
                Io,
                Oo(Mf(n.dl))
            ]), {
                cr: n.cr,
                dl: f("/images/screenshots/", n.dl)
            })
        ]));
    }, fb = d([
        {
            cr: "boardImage",
            dl: "boardScreenshot.png"
        },
        {
            cr: "imageMatch",
            dl: "imageMatchScreenshot.png"
        },
        {
            cr: "levelSelect",
            dl: "levelSelectScreenshot.png"
        }
    ]), sb = Qs({
        a3: 100,
        bn: 0,
        bF: 0,
        bL: 0
    }), bb = A2(Tf, d([
        sb,
        ao(rf)
    ]), d([
        A2(Tf, d([
            ao(rf),
            Vf(A4(gf, 137, 209, 254, .2)),
            Df,
            A2(uf, 20, 50)
        ]), d([
            A2(Tf, d([
                bo(af("screenshotsContainer")),
                Df,
                Wf,
                ao(rf)
            ]), A2(St, ob, fb))
        ]))
    ])), lb = A2(Tf, d([
        sb
    ]), d([
        A2(us, d([
            ao(rf),
            Df,
            To(20),
            Vf(A4(gf, 137, 209, 254, .2))
        ]), A2(St, ob, fb))
    ])), db = function(n) {
        return n.aK.aJ ? bb : lb;
    }, vb = function(n) {
        switch(n){
            case 0:
                return tf(175);
            case 1:
                return tf(250);
            default:
                return tf(350);
        }
    }, hb = function(n) {
        return A2(Cf, d([
            Df,
            Wf,
            js(20),
            zs,
            ao(vb(n)),
            ro(vb(n)),
            Uf
        ]), {
            cr: "appIcon",
            dl: "images/appIcon.svg"
        });
    }, pb = F2(function(n, r) {
        return A2(ps, d([
            bo(Ys("_blank")),
            Df,
            Qs({
                a3: 60,
                bn: 0,
                bF: 0,
                bL: 0
            })
        ]), {
            cO: hb(r),
            dI: n
        });
    }), gb = Ma(0), mb = A2(po, bs, "tl"), wb = function(n) {
        switch(n){
            case 0:
            case 2:
            default:
                return mb;
            case 1:
                return ls;
        }
    }, $b = F2(function(n, r) {
        return A2(Tf, d([
            Df,
            ao(rf),
            To(5)
        ]), d([
            A2(us, d([
                Qs({
                    a3: 2,
                    bn: 0,
                    bF: 10,
                    bL: 2
                }),
                fo(A3(So, 235, 55, 104)),
                gb,
                As
            ]), d([
                Qo("\u2022")
            ])),
            A2(us, d([
                ao(rf)
            ]), d([
                A2(ys, d([
                    wb(n)
                ]), d([
                    Qo(r)
                ]))
            ]))
        ]));
    }), xb = d([
        "300 levels of content!",
        "Every kana and vocabulary word is beautifully voice acted",
        "Learn hiragana and katakana stroke order as you play"
    ]), yb = d([
        "300\u30EC\u30D9\u30EB\u306E\u5185\u5BB9",
        "\u8CED\u535A\u306E\u4ED5\u7D44\u307F\u3001\u30A2\u30D7\u30EA\u306E\u8CFC\u5165\u3001\u5E83\u544A\u306F\u3042\u308A\u307E\u305B\u3093",
        "\u904A\u3073\u306A\u304C\u3089\u3072\u3089\u304C\u306A\u3068\u30AB\u30BF\u30AB\u30CA\u306E\u66F8\u304D\u9806\u3092\u5B66\u3076",
        "\u697D\u3057\u307F\u3092\u904E\u7D66\u3059\u308B\u30DC\u30FC\u30CA\u30B9\u3067\u5927\u898F\u6A21\u306A\u9023\u9396\u53CD\u5FDC\u3092\u4F5C\u6210\u3057\u307E\u3059"
    ]), kb = F2(function(n, r) {
        return A2(us, d([
            Df,
            ao(rf)
        ]), A2(St, $b(n), r ? yb : xb));
    }), jb = function(n) {
        switch(n){
            case 0:
                return qo(20);
            case 1:
                return qo(22);
            default:
                return qo(26);
        }
    }, Kb = function(n) {
        switch(n){
            case 0:
                return Qs({
                    a3: 30,
                    bn: 40,
                    bF: 20,
                    bL: 40
                });
            case 1:
                return To(60);
            case 2:
                return Qs({
                    a3: 80,
                    bn: 60,
                    bF: 60,
                    bL: 120
                });
            default:
                return Qs({
                    a3: 100,
                    bn: 60,
                    bF: 60,
                    bL: 140
                });
        }
    }, Ab = function(n) {
        switch(n){
            case 0:
                return To(30);
            case 1:
                return To(50);
            default:
                return A2(uf, 100, 100);
        }
    }, Cb = F2(function(n, r) {
        return A2(Tf, d([
            Df,
            ao(rf),
            Ab(n),
            jb(n)
        ]), d([
            A2(us, d([
                Df,
                Kb(n),
                ao(rf),
                Vf(A3(So, 242, 242, 242))
            ]), r)
        ]));
    }), Jb = function(n) {
        switch(n){
            case 0:
                return qo(22);
            case 1:
                return qo(25);
            default:
                return qo(32);
        }
    }, Lb = function(n) {
        return n ? "\u7279\u5FB4" : "Features";
    }, zb = F2(function(n, r) {
        return A2(Tf, d([
            ao(rf),
            Qs({
                a3: 15,
                bn: 0,
                bF: 0,
                bL: 40
            }),
            Go,
            Jb(n)
        ]), d([
            A2(ys, d([
                wb(n)
            ]), d([
                Qo(Lb(r))
            ]))
        ]));
    }), Sb = nf, Nb = F3(function(n, r, t) {
        return A2(Tf, d([
            Df,
            ao(A2(Js, 1665, rf)),
            Ab(n),
            jb(n)
        ]), d([
            A2(Tf, d([
                Df,
                Vf(A3(So, 242, 242, 242)),
                Kb(n),
                ao(rf)
            ]), d([
                A2(us, d([
                    Df,
                    ao(Sb(1)),
                    As
                ]), d([
                    r
                ])),
                A2(us, d([
                    ao(Sb(2)),
                    Qs({
                        a3: 0,
                        bn: 50,
                        bF: 0,
                        bL: 0
                    })
                ]), t)
            ]))
        ]));
    }), _b = function(n) {
        return n ? cs(n) + "\n            \u306F\u8A00\u8A9E\u5B66\u7FD2\u3092\u7D44\u307F\u8FBC\u3080\u65B0\u3057\u3044\u30B9\u30DE\u30DB\u30DE\u30C3\u30C1\uFF13\u30B2\u30FC\u30E0\u3067\u3059\u3002\n            \u8AAD\u3080\u3053\u3068\u3092\u52C9\u5F37\u3059\u308B\u306E\u306F\u9000\u5C48\u306A\u3053\u3068\u306B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3001\u30B2\u30FC\u30E0\u30D7\u30EC\u30A4\u306F\u5922\u4E2D\u306B\u3055\u305B\u3001\u8208\u5473\u3092\u6301\u305F\u305B\u308B\u3002\n            " : cs(n) + " is a new take on the match-3 game format by incorporating language learning for the first time! Getting started with basic Japanese vocabulary doesn't have to be a boring chore for students and beginners alike as the gameplay keeps them engaged and interested.";
    }, Fb = F5(function(n, r, t, e, a) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e,
            e: a
        };
    }), Rb = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), Ob = F4(function(n, r, t, e) {
        return "pad-" + Vu(n) + "-" + Vu(r) + "-" + Vu(t) + "-" + Vu(e);
    }), Hb = Hs, Pb = F2(function(n, r) {
        var t = function(n) {
            return A3(zt, F2(function(n, r) {
                var t = r.a, e = r.b;
                return i(function() {
                    if (t.$) {
                        if (4 === n.$ && 7 === n.b.$) {
                            var r = n.b;
                            return zr(A5(Fb, r.a, r.b, r.c, r.d, r.e));
                        }
                        return Sr;
                    }
                    return t;
                }(), function() {
                    if (e.$) {
                        if (4 === n.$ && 5 === n.b.$) {
                            var r = n.b;
                            return zr(A3(Rb, r.a, r.b, r.c));
                        }
                        return Sr;
                    }
                    return e;
                }());
            }), i(Sr, Sr), n);
        }(n), e = t.a, u = t.b;
        if (1 === u.$) return A4(Yc, 0, Va, A2(xr, Af("cl ccy " + zu), A2(xr, ao(to), A2(xr, ro(to), n))), Wa(r));
        var c = u.a, o = c.a, b = c.b, l = c.c, v = function() {
            if (e.$) return Sr;
            var n = e.a, r = n.b, t = n.c, u = n.d, i = n.e;
            if (a(t, b / 2) > -1 && a(u, l / 2) > -1) {
                var c = r - l / 2, o = t - b / 2, f = i - b / 2, s = u - l / 2;
                return zr(A2(Oa, Po, A5(Ho, A4(Ob, c, o, s, f), c, o, s, f)));
            }
            return Sr;
        }();
        if (v.$) {
            var h = -l / 2, p = -b / 2;
            return A4(Yc, 2, Va, n, Wa(d([
                A4(Yc, 0, Va, A2(xr, Af("cl ccy " + zu), A2(xr, so(A2(Hb, "margin", ai(h) + "px " + ai(p) + "px")), A2(xr, so(A2(Hb, "width", "calc(100% + " + Nr(b) + "px)")), A2(xr, so(A2(Hb, "height", "calc(100% + " + Nr(l) + "px)")), A2(xr, A2(Oa, $s, A3(ws, o, b, l)), s))))), Wa(r))
            ])));
        }
        var g = v.a;
        return A4(Yc, 0, Va, A2(xr, Af("cl ccy " + zu), A2(xr, ao(to), A2(xr, ro(to), f(n, d([
            g
        ]))))), Wa(r));
    }), Tb = F2(function(n, r) {
        return A2(Pb, d([
            ao(rf)
        ]), d([
            A2(ys, d([
                wb(n)
            ]), d([
                Qo(_b(r))
            ]))
        ]));
    }), Eb = function(n) {
        switch(n.aK.aJ){
            case 0:
            case 1:
                return function(n) {
                    return A2(Cb, n.aK.aJ, d([
                        A2(pb, "https://play.kanaparty.com", n.aK.aJ),
                        gs,
                        A2(zb, n.aK.aJ, n.bm),
                        A2(kb, n.aK.aJ, n.bm)
                    ]));
                }(n);
            default:
                return function(n) {
                    return A3(Nb, n.aK.aJ, A2(pb, "https://play.kanaparty.com", n.aK.aJ), d([
                        A2(Tb, n.aK.aJ, n.bm),
                        gs,
                        A2(zb, n.aK.aJ, n.bm),
                        A2(kb, n.aK.aJ, n.bm)
                    ]));
                }(n);
        }
    }, Ib = function(n) {
        return d([
            cb,
            ib(n),
            ab(n),
            Eb(n),
            db(n),
            Us(n)
        ]);
    }, Qb = function(n) {
        return qo(0 === n ? 19 : 26);
    }, Bb = function(n) {
        switch(n){
            case 0:
                return Qs({
                    a3: 20,
                    bn: 0,
                    bF: 0,
                    bL: 75
                });
            case 1:
                return Qs({
                    a3: 20,
                    bn: 30,
                    bF: 30,
                    bL: 75
                });
            case 2:
                return Qs({
                    a3: 20,
                    bn: 30,
                    bF: 30,
                    bL: 120
                });
            default:
                return Qs({
                    a3: 20,
                    bn: 40,
                    bF: 40,
                    bL: 120
                });
        }
    }, Mb = function(n) {
        return n ? "\u500B\u4EBA\u60C5\u5831\u3068\u306F\u3001\u7279\u5B9A\u3055\u308C\u305F\u3001\u307E\u305F\u306F\u7279\u5B9A\u53EF\u80FD\u306A\u81EA\u7136\u4EBA\u306B\u95A2\u9023\u3059\u308B\u60C5\u5831\u3067\u3059\u3002" : "Personal information is any information which is related to an identified or identifiable natural person.";
    }, Db = function(n) {
        return n ? "\u3044\u3044\u3048\u3001\u30B2\u30FC\u30E0\u306F\u500B\u4EBA\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u305B\u3093\u3002" : "No, the game does not collect any personal information.";
    }, Wb = function(n) {
        return n ? "\u3044\u3044\u3048\u3001\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306F\u500B\u4EBA\u60C5\u5831\u3092\u53CE\u96C6\u305B\u305A\u3001Cookie\u3092\u4F7F\u7528\u3057\u3066\u3042\u306A\u305F\u306E\u500B\u4EBA\u3092\u7279\u5B9A\u3059\u308B\u60C5\u5831\u3092\u53CE\u96C6\u3059\u308B\u3053\u3068\u3082\u3042\u308A\u307E\u305B\u3093" : "No, the website does not collect any personal information and does not use cookies to collect personally identifying information about you.";
    }, Vb = function(n) {
        return n ? "\n            \u304A\u5BA2\u69D8\u304C\u901A\u4FE1\u3059\u308B\u5834\u5408\u3001\u30B5\u30DD\u30FC\u30C8\u76EE\u7684\u3067\u4F7F\u7528\u3055\u308C\u308B\u305F\u3081\u306B\u96FB\u5B50\u30E1\u30FC\u30EB\u3092\u4ECB\u3057\u3066\u81EA\u767A\u7684\u306B\u500B\u4EBA\u60C5\u5831\u3092\u63D0\u4F9B\u3059\u308B\u3053\u3068\u3092\u9078\u629E\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\n            \u81EA\u4E3B\u7684\u306B\u63D0\u4F9B\u3055\u308C\u305F\u500B\u4EBA\u60C5\u5831\u306F\u3001\u8981\u6C42\u306B\u5FDC\u3058\u3066\u524A\u9664\u3055\u308C\u307E\u3059\u3002\n            " : "\n            If you communicate with us, you may choose to provide personal information voluntarily via email to be used for support purposes. \n            Any voluntarily provided personal information will be deleted upon request.\n            ";
    }, qb = function(n) {
        return n ? cs(n) + "\u30A2\u30D7\u30EA\u306F\u79C1\u306E\u500B\u4EBA\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u304B\uFF1F" : "Does the " + cs(n) + " App Collect My Personal Information?";
    }, Ub = function(n) {
        return n ? cs(n) + "\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306F\u79C1\u306E\u500B\u4EBA\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u304B\uFF1F" : "Does the " + cs(n) + " Website Collect My Personal Information?";
    }, Zb = function(n) {
        return n ? cs(n) + "\u306B\u60C5\u5831\u3092\u63D0\u4F9B\u3059\u308B\u3068\u3069\u3046\u306A\u308A\u307E\u3059\u304B\uFF1F" : "What Happens if I Provide Information to " + cs(n) + "?";
    }, Gb = F2(function(n, r) {
        return A2(us, d([
            A2(uf, 0, 20),
            mb
        ]), d([
            A2(ys, d([
                Go,
                A2(uf, 0, 7)
            ]), d([
                Qo(n)
            ])),
            A2(ys, d([
                qo(18)
            ]), d([
                Qo(r)
            ]))
        ]));
    }), Xb = function(n) {
        switch(n){
            case 0:
                return qo(32);
            case 1:
                return qo(42);
            default:
                return qo(46);
        }
    }, Yb = function(n) {
        var r;
        return A2(us, d([
            ao(rf),
            Df,
            A2(uf, 0, 15),
            ls
        ]), d([
            A2(ys, d([
                ls,
                Xb(n.aK.aJ),
                Go
            ]), d([
                Qo(Vs(n.bm))
            ])),
            A2(ys, d([
                Qs({
                    a3: 0,
                    bn: 0,
                    bF: 0,
                    bL: 20
                }),
                qo(21)
            ]), d([
                Qo((r = n.bm, r ? cs(r) + "\u306F\u3001\u304A\u5BA2\u69D8\u306E\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u3092\u4FDD\u8B77\u3057\u3001\u5C0A\u91CD\u3059\u308B\u3053\u3068\u3092\u304A\u7D04\u675F\u3057\u307E\u3059\u3002" : cs(r) + " is committed to protecting and respecting your privacy!"))
            ]))
        ]));
    }, nl = function(n) {
        var r;
        return A2(us, d([
            ao(rf),
            A2(uf, 30, 30),
            js(10),
            Vf(A3(So, 255, 255, 255)),
            Uf
        ]), d([
            Yb(n),
            A2(Gb, (r = n.bm, r ? "\u500B\u4EBA\u60C5\u5831\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F" : "What is Personal Information?"), Mb(n.bm)),
            A2(Gb, qb(n.bm), Db(n.bm)),
            A2(Gb, Ub(n.bm), Wb(n.bm)),
            A2(Gb, Zb(n.bm), Vb(n.bm))
        ]));
    }, rl = function(n) {
        return 0 === n.aK.aJ ? function(n) {
            return A2(us, d([
                As,
                Df,
                Wf,
                ao(A2(Js, 420, rf))
            ]), d([
                nl(n)
            ]));
        }(n) : function(n) {
            return A2(Tf, d([
                As,
                Df,
                Wf,
                ao(A2(Js, 1e3, rf))
            ]), d([
                nl(n)
            ]));
        }(n);
    }, tl = function(n) {
        var r;
        return A2(Tf, d([
            ao(rf),
            Df,
            Os(1),
            (r = n.aK.aJ, bo(Bu(0 === r ? "" : "fullViewportHeight"))),
            Bb(n.aK.aJ),
            Qb(n.aK.aJ),
            Ps(Fs)
        ]), d([
            A2(us, d([
                Df,
                ro(rf),
                ao(rf),
                A2(uf, 40, 40)
            ]), d([
                rl(n)
            ]))
        ]));
    }, el = Xf(A3(Yf, "style", s, d([
        pc('\nbody { \n    background: url("/images/background/backgroundNoLogo.svg"); \n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-position: center;\n    background-size: cover; \n    } \n    ')
    ]))), al = zn("d"), ul = kn("http://www.w3.org/2000/svg"), il = ul("defs"), cl = zn("dx"), ol = zn("dy"), fl = ul("feComposite"), sl = ul("feFlood"), bl = ul("feGaussianBlur"), ll = ul("feOffset"), dl = zn("fill"), vl = ul("filter"), hl = zn("filter"), pl = zn("filterUnits"), gl = zn("flood-color"), ml = zn("flood-opacity"), wl = ul("g"), $l = zn("height"), xl = zn("id"), yl = zn("in2"), kl = zn("in"), jl = zn("operator"), Kl = ul("path"), Al = ul("rect"), Cl = zn("result"), Jl = zn("rx"), Ll = zn("stdDeviation"), zl = zn("stroke"), Sl = zn("stroke-dasharray"), Nl = zn("stroke-dashoffset"), _l = zn("stroke-linecap"), Fl = zn("stroke-linejoin"), Rl = zn("stroke-miterlimit"), Ol = zn("stroke-width"), Hl = ul("svg"), Pl = zn("version"), Tl = zn("width"), El = zn("x"), Il = zn("y"), Ql = A2(Hl, d([
        Pl("1.1"),
        Tl("125"),
        $l("125"),
        xl("canvasAnimatedKaComplete")
    ]), d([
        A2(il, s, d([
            A2(vl, d([
                xl("canvasAnimatedKaComplete-shadow2-outer"),
                pl("objectBoundingBox")
            ]), d([
                A2(bl, d([
                    Ll("2.5")
                ]), s),
                A2(ll, d([
                    cl("2"),
                    ol("2"),
                    Cl("blur")
                ]), s),
                A2(sl, d([
                    gl("rgb(85, 85, 85)"),
                    ml("0.7")
                ]), s),
                A2(fl, d([
                    yl("blur"),
                    jl("in"),
                    Cl("colorShadow")
                ]), s),
                A2(fl, d([
                    kl("SourceGraphic"),
                    yl("colorShadow"),
                    jl("over")
                ]), s)
            ]))
        ])),
        A2(Al, d([
            xl("canvasAnimatedKaComplete-rectangle2"),
            zl("none"),
            dl("rgb(251, 251, 248)"),
            hl("url(#canvasAnimatedKaComplete-shadow2-outer)"),
            El("12"),
            Il("12"),
            Tl("100"),
            $l("100"),
            Jl("10")
        ]), s),
        A2(wl, d([
            xl("canvasAnimatedKaComplete-group")
        ]), d([
            A2(wl, d([
                xl("canvasAnimatedKaComplete-group2")
            ]), d([
                A2(wl, d([
                    xl("canvasAnimatedKaComplete-greyKa")
                ]), d([
                    A2(Kl, d([
                        xl("canvasAnimatedKaComplete-bezier4"),
                        zl("rgb(170, 170, 170)"),
                        Ol("9.57"),
                        _l("round"),
                        Fl("round"),
                        Rl("10"),
                        dl("none"),
                        al("M 33.08,49.21 C 48.34,51.7 73.54,38.96 73.6,58.03 73.68,82.85 65.93,88.36 59.41,94.82 59.41,94.82 59.25,90.4 53.52,85.88")
                    ]), s),
                    A2(Kl, d([
                        xl("canvasAnimatedKaComplete-bezier5"),
                        zl("rgb(170, 170, 170)"),
                        Ol("9.57"),
                        _l("round"),
                        Fl("round"),
                        Rl("10"),
                        dl("none"),
                        al("M 62.89,33 C 55.09,47.87 40.46,75.28 32,87.41")
                    ]), s),
                    A2(Kl, d([
                        xl("canvasAnimatedKaComplete-bezier6"),
                        zl("rgb(170, 170, 170)"),
                        Ol("9.57"),
                        _l("round"),
                        Fl("round"),
                        Rl("10"),
                        dl("none"),
                        al("M 86.24,45.14 C 91.65,47.13 96.55,59.06 97.81,63.4")
                    ]), s)
                ])),
                A2(wl, d([
                    xl("canvasAnimatedKaComplete-blackKa")
                ]), d([
                    A2(Kl, d([
                        xl("canvasAnimatedKaComplete-bezier2"),
                        zl("rgb(0, 0, 0)"),
                        Ol("9.57"),
                        _l("round"),
                        Fl("round"),
                        Rl("10"),
                        Sl("128,64"),
                        Nl("1"),
                        dl("none"),
                        al("M 62.89,33 C 55.09,47.87 40.46,75.28 32,87.41")
                    ]), s),
                    A2(Kl, d([
                        xl("canvasAnimatedKaComplete-bezier3"),
                        zl("rgb(0, 0, 0)"),
                        Ol("9.57"),
                        _l("round"),
                        Fl("round"),
                        Rl("10"),
                        Sl("24,24"),
                        Nl("1"),
                        dl("none"),
                        al("M 86.24,45.14 C 91.65,47.13 96.55,59.06 97.81,63.4")
                    ]), s),
                    A2(Kl, d([
                        xl("canvasAnimatedKaComplete-bezier"),
                        zl("rgb(0, 0, 0)"),
                        Ol("9.57"),
                        _l("round"),
                        Fl("round"),
                        Rl("10"),
                        Sl("101,101"),
                        Nl("1"),
                        dl("none"),
                        al("M 33.08,49.21 C 48.34,51.7 73.54,38.96 73.6,58.03 73.68,82.85 65.93,88.36 59.41,94.82 59.41,94.82 59.25,90.4 53.52,85.88")
                    ]), s)
                ]))
            ]))
        ]))
    ])), Bl = {
        cr: "Ka Shape",
        dl: "images/support/kaShape.svg"
    }, Ml = {
        cr: "Right Arrow",
        dl: "images/support/rightArrow.svg"
    }, Dl = A2(Tf, d([
        Df,
        A2(uf, 0, 30)
    ]), d([
        A2(Cf, d([
            ao(tf(75)),
            ro(tf(75))
        ]), Bl),
        A2(Cf, d([
            ao(tf(50)),
            ro(tf(50))
        ]), Ml),
        A2(us, s, d([
            Xf(Ql)
        ]))
    ])), Wl = {
        cr: "Level Select Chevrons",
        dl: "images/support/levelSelectChevrons.svg"
    }, Vl = function(n) {
        switch(n){
            case 0:
                return ro(tf(213));
            case 1:
                return ro(tf(426));
            default:
                return ro(tf(852));
        }
    }, ql = function(n) {
        switch(n){
            case 0:
                return ao(tf(120));
            case 1:
                return ao(tf(240));
            default:
                return ao(tf(480));
        }
    }, Ul = F2(function(n, r) {
        return A2(Cf, d([
            ql(n.aK.aJ),
            Vl(n.aK.aJ),
            Df
        ]), r);
    }), Zl = {
        cr: "Next Image",
        dl: "images/support/nextImage.svg"
    }, Gl = function(n) {
        switch(n){
            case 0:
                return tf(40);
            case 1:
                return tf(60);
            default:
                return tf(90);
        }
    }, Xl = function(n) {
        return A2(Tf, d([
            Df
        ]), d([
            A2(Ul, n, Wl),
            A2(Cf, d([
                ao(Gl(n.aK.aJ)),
                ro(Gl(n.aK.aJ))
            ]), Ml),
            A2(Ul, n, Zl)
        ]));
    }, Yl = function(n) {
        switch(n){
            case 0:
                return qo(18);
            case 1:
                return qo(22);
            case 2:
                return qo(23);
            default:
                return qo(24);
        }
    }, nd = A2(po, Zo, "w4"), rd = function(n) {
        var r;
        return A2(ys, d([
            To(20),
            nd,
            Yl(n.aK.aJ)
        ]), d([
            Qo((r = n.bm, r ? cs(r) + "\n            \u306F\u3001\u4EEE\u540D\u3092\u30DE\u30C3\u30C1\u3055\u305B\u3066\u4EEE\u540D\u30BF\u30A4\u30EB\u3092\u57CB\u3081\u308B\u30DE\u30C3\u30C13\u30B2\u30FC\u30E0\u3067\u3059\u3002\n            \u8A00\u8449\u306E\u4EEE\u540D\u30BF\u30A4\u30EB\u304C\u5168\u3066\u5165\u529B\u3055\u308C\u305F\u3089\u3001\u5BFE\u5FDC\u3059\u308B\u8A00\u8449\u3092\u305D\u306E\u7D75\u306B\u4E00\u81F4\u3055\u305B\u307E\u3059\u3002\n            \u5404\u30EC\u30D9\u30EB\u3092\u7D42\u4E86\u3059\u308B\u305F\u3081\u306B4\u3064\u306E\u8A00\u8449\u3059\u3079\u3066\u3092\u7D75\u306B\u4E00\u81F4\u3055\u305B\u3066\u3002\n            " : cs(r) + "\n            is a match 3 game where you match kana to fill in its kana tile.\n            After all tiles of a word are filled in you then match the corresponding word to its image.\n            Finish each level by matching all four words to their image.\n            "))
        ]));
    }, td = {
        cr: "Image Matching",
        dl: "images/support/imageMatching.svg"
    }, ed = function(n) {
        switch(n){
            case 0:
                return ro(tf(400));
            case 1:
                return ro(tf(480));
            default:
                return ro(tf(600));
        }
    }, ad = function(n) {
        switch(n){
            case 0:
                return ao(tf(250));
            case 1:
                return ao(tf(300));
            default:
                return ao(tf(375));
        }
    }, ud = function(n) {
        return A2(us, d([
            Df,
            To(0)
        ]), d([
            A2(Cf, d([
                ad(n.aK.aJ),
                ed(n.aK.aJ),
                Df
            ]), td)
        ]));
    }, id = {
        cr: "Kana Swap Horizontal Match",
        dl: "images/support/kanaSwapHorizontal.svg"
    }, cd = function(n) {
        switch(n){
            case 0:
                return tf(225);
            case 1:
                return tf(263);
            default:
                return tf(300);
        }
    }, od = function(n) {
        switch(n){
            case 0:
                return tf(150);
            case 1:
                return tf(175);
            default:
                return tf(200);
        }
    }, fd = function(n) {
        return A2(us, d([
            Df,
            To(20)
        ]), d([
            A2(Cf, d([
                ao(cd(n.aK.aJ)),
                ro(od(n.aK.aJ)),
                Df
            ]), id)
        ]));
    }, sd = {
        cr: "Kana Swap Vertical Match",
        dl: "images/support/kanaSwapVertical.svg"
    }, bd = function(n) {
        return A2(us, d([
            Df,
            To(20)
        ]), d([
            A2(Cf, d([
                ao(od(n.aK.aJ)),
                ro(cd(n.aK.aJ)),
                Df
            ]), sd)
        ]));
    }, ld = function(n) {
        return 0 === n.aK.aJ ? function(n) {
            return A2(us, d([
                Df,
                ao(rf)
            ]), d([
                fd(n),
                bd(n)
            ]));
        }(n) : function(n) {
            return A2(Tf, d([
                Df,
                ao(rf)
            ]), d([
                fd(n),
                bd(n)
            ]));
        }(n);
    }, dd = {
        cr: "Level Select Sounds",
        dl: "images/support/levelSelectSounds.svg"
    }, vd = function(n) {
        switch(n){
            case 0:
                return Qs({
                    a3: 10,
                    bn: 10,
                    bF: 10,
                    bL: 10
                });
            case 1:
                return Qs({
                    a3: 10,
                    bn: 30,
                    bF: 40,
                    bL: 10
                });
            default:
                return Qs({
                    a3: 10,
                    bn: 50,
                    bF: 70,
                    bL: 10
                });
        }
    }, hd = F2(function(n, r) {
        return A2(Tf, d([
            Df,
            ao(rf),
            vd(n.aK.aJ),
            nd,
            Yl(n.aK.aJ)
        ]), d([
            A2(us, d([
                Qs({
                    a3: 2,
                    bn: 20,
                    bF: 10,
                    bL: 2
                }),
                gb,
                As
            ]), d([
                Qo("\u2022")
            ])),
            A2(us, d([
                ao(rf)
            ]), d([
                A2(ys, s, d([
                    Qo(r)
                ]))
            ]))
        ]));
    }), pd = function(n) {
        return n ? "\u73FE\u5728\u306E\u4EEE\u540D\u30BF\u30A4\u30EB\u3092\u5B8C\u6210\u3055\u305B\u308B\u305F\u3081\u306B\u3001\u304A\u306A\u3058\u4EEE\u540D\u306E\u56F3\u5F62\u3092\u3042\u308F\u305B\u307E\u3059\u3002" : "Complete the current kana tile by matching kana of the same type on the board.";
    }, gd = function(n) {
        return n ? "\u4EEE\u540D\u306E\u56F3\u5F62\u3092\u30B9\u30EF\u30A4\u30D7\u3057\u3066\u3001\u540C\u3058\u4EEE\u540D\u30923\u3064\u4EE5\u4E0A\u5408\u308F\u305B\u307E\u3059\u3002" : "Swipe the shapes on the board to line up three or more of the same kana.";
    }, md = function(n) {
        return n ? "\u304B\u306A\u307E\u305F\u306F\u7D75\u3092\u89E6\u308B\u3068\u3001\u5BFE\u5FDC\u3059\u308B\u30B5\u30A6\u30F3\u30C9\u304C\u518D\u751F\u3055\u308C\u307E\u3059\u3002" : "Tapping on the kana or the image plays their corresponding sound.";
    }, wd = function(n) {
        return n ? "\u4E00\u81F4\u3059\u308B\u8A00\u8449\u306B\u5BFE\u5FDC\u3059\u308B\u7D75\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059\u3002" : "Tap on the image that corresponds to the matching kana word.";
    }, $d = function(n) {
        var r, t;
        return A2(us, d([
            (t = n.aK.aJ, To(0 === t ? 0 : 10))
        ]), d([
            rd(n),
            A2(hd, n, (r = n.bm, r ? "\u30EC\u30D9\u30EB\u3092\u518D\u751F\u3059\u308B\u524D\u306B\u3001\u30EC\u30D9\u30EB\u9078\u629E\u30C9\u30ED\u30C3\u30D7\u30C0\u30A6\u30F3\u306E\u5DE6\u53F3\u306E\u77E2\u5370\u3092\u4F7F\u7528\u3057\u3066\u7D75\u3092\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044\u3002" : "Before playing a level be sure to scroll through the images using the left and right arrows on the level selection drop down.")),
            Xl(n),
            A2(hd, n, md(n.bm)),
            A2(Ul, n, dd),
            A2(hd, n, gd(n.bm)),
            ld(n),
            A2(hd, n, pd(n.bm)),
            Dl,
            A2(hd, n, wd(n.bm)),
            ud(n)
        ]));
    }, xd = F3(function(n, r, t) {
        return A4(zo, n, r, t, 1);
    }), yd = function(n) {
        switch(n){
            case 0:
                return Qs({
                    a3: 20,
                    bn: 5,
                    bF: 5,
                    bL: 120
                });
            case 1:
            case 2:
                return Qs({
                    a3: 20,
                    bn: 30,
                    bF: 30,
                    bL: 120
                });
            default:
                return Qs({
                    a3: 20,
                    bn: 40,
                    bF: 40,
                    bL: 120
                });
        }
    }, kd = function(n) {
        switch(n){
            case 0:
                return qo(15);
            case 1:
                return qo(18);
            default:
                return qo(22);
        }
    }, jd = F2(function(n, r) {
        return A2(Tf, d([
            kd(n),
            Vf(A3(So, 181, 80, 241)),
            fo(A3(So, 255, 255, 255)),
            ls,
            ao(rf),
            Qs({
                a3: 7,
                bn: 10,
                bF: 10,
                bL: 12
            })
        ]), d([
            Qo(r)
        ]));
    }), Kd = function(n) {
        var r;
        return A2(Tf, d([
            bo(af("supportContainer")),
            Df,
            Os(1),
            Go,
            yd(n.aK.aJ),
            ao(tf(xa(n.bQ.bQ.bR)))
        ]), d([
            A2(us, d([
                Df,
                ao(rf)
            ]), d([
                A2(us, d([
                    Vf(A3(xd, 1, 1, 1)),
                    Uf,
                    js(10),
                    Yo(A3(So, 200, 111, 241)),
                    of(5),
                    ao(rf)
                ]), d([
                    A2(jd, n.aK.aJ, (r = n.bm, r ? cs(r) + "\u306F\u3069\u3046\u3084\u3063\u3066\u30D7\u30EC\u30A4\u3057\u307E\u3059\u304B\uFF1F" : "How do I play " + cs(r) + "?")),
                    $d(n)
                ]))
            ]))
        ]));
    }, Ad = function(n) {
        return A2(us, function(n) {
            return t(n.a6, zr(2)), is;
        }(n), function(n) {
            var r = n.a6;
            if (r.$) return Ib(n);
            switch(r.a){
                case 0:
                    return Ib(n);
                case 1:
                    return function(n) {
                        return d([
                            Ts(n),
                            Us(n)
                        ]);
                    }(n);
                case 2:
                    return function(n) {
                        return d([
                            Kd(n),
                            el,
                            Us(n)
                        ]);
                    }(n);
                default:
                    return function(n) {
                        return d([
                            tl(n),
                            Us(n)
                        ]);
                    }(n);
            }
        }(n));
    }, Cd = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Jd = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ld = {
        b5: Sr,
        cb: Sr,
        de: zr({
            _: 0,
            aa: A4(zo, 155 / 255, 203 / 255, 1, 1),
            bs: i(0, 0),
            ad: 3
        })
    }, zd = F2(function(n, r) {
        switch(r.$){
            case 0:
                return (0, r.a)(2);
            case 1:
                return A2(r.a.cD, n(r.a.$7), 2);
            case 2:
                return gc(r.a);
            default:
                return gc("");
        }
    }), Sd = F3(function(n, r, t) {
        var e = function(n) {
            var r, t, e, a;
            return {
                cy: (a = (r = A3(zt, F2(function(n, r) {
                    switch(n.$){
                        case 0:
                            return 1 === r.cC.$ ? o(r, {
                                cC: zr(n.a)
                            }) : r;
                        case 1:
                            return 1 === r.cy.$ ? o(r, {
                                cy: zr(n.a)
                            }) : r;
                        default:
                            return 1 === r.cR.$ ? o(r, {
                                cR: zr(n.a)
                            }) : r;
                    }
                }), {
                    cy: Sr,
                    cC: Sr,
                    cR: Sr
                }, n)).cy, 1 === a.$ ? Ld : a.a),
                cC: (e = r.cC, 1 === e.$ ? 1 : e.a),
                cR: (t = r.cR, 1 === t.$ ? 0 : t.a)
            };
        }(n), a = 1 === e.cR ? Cd(e) : Jd(e);
        return A2(zd, a, A4(Yc, 2, Va, r, Wa(d([
            t
        ]))));
    }), Nd = (la = d([
        ts("Open Sans"),
        ts("Helvetica"),
        ts("Verdana"),
        {
            $: 1
        }
    ]), d([
        A2(Oa, sf, A3(io, "bg-" + oo(A4(zo, 1, 1, 1, 0)), "background-color", A4(zo, 1, 1, 1, 0))),
        A2(Oa, co, A3(io, "fc-" + oo(A4(zo, 0, 0, 0, 1)), "color", A4(zo, 0, 0, 0, 1))),
        A2(Oa, Vo, Wo(20)),
        A2(Oa, Pa, A2(Ra, A3(Rr, Ia, "font-", la), la))
    ])), _d = F3(function(n, r, t) {
        return A3(Sd, n.bt, A2(xr, Af(A2(_r, " ", d([
            "ui",
            eu,
            yu
        ]))), f(Nd, r)), t);
    })({
        bt: s
    }), Fd = F2(function(n, r) {
        return t(r.a6, n.a6) && t(r.bm, n.bm);
    }), Rd = d([
        {
            a6: 0,
            bm: 0,
            C: "Kana Party"
        },
        {
            a6: 2,
            bm: 0,
            C: "Kana Party - Support"
        },
        {
            a6: 1,
            bm: 0,
            C: "Kana Party - About Us"
        },
        {
            a6: 3,
            bm: 0,
            C: "Kana Party - Privacy Policy"
        },
        {
            a6: 0,
            bm: 1,
            C: "\u304B\u306A\u30D1\u30FC\u30C6\u30A3\u30FC"
        },
        {
            a6: 2,
            bm: 1,
            C: "\u30B5\u30DD\u30FC\u30C8"
        },
        {
            a6: 1,
            bm: 1,
            C: "\u958B\u767A\u8005\u306E\u6982\u8981"
        },
        {
            a6: 3,
            bm: 1,
            C: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
        }
    ]), Od = F2(function(n, r) {
        var t = Ce(A2(Ae, Fd({
            a6: r,
            bm: n
        }), Rd));
        return t.$ ? "" : t.a.C;
    }), Hd = function(n) {
        var r = n.a6;
        return r.$ ? cs(n.bm) : A2(Od, n.bm, r.a);
    };
    da = {
        Main: {
            init: (ha = (va = {
                cH: Pe,
                cZ: function(n) {
                    return {
                        $: 12,
                        a: n
                    };
                },
                c_: function(n) {
                    return {
                        $: 13,
                        a: n
                    };
                },
                dp: function() {
                    var n;
                    return Ee(d([
                        Me(Dt),
                        (n = Te, A3(wa, 1, "resize", A2(Qe, "target", A3(ot, n, A2(Qe, "innerWidth", De), A2(Qe, "innerHeight", De)))))
                    ]));
                },
                dH: Fa,
                dJ: function(n) {
                    return {
                        b9: d([
                            A2(_d, as(n), A2(us, d([
                                ao(rf),
                                ro(rf)
                            ]), d([
                                Ad(n)
                            ])))
                        ]),
                        C: Hd(n)
                    };
                }
            }).cZ, pa = va.c_, ga = function() {
                ga.a(ha(fr()));
            }, cr({
                aV: function(n) {
                    return ga.a = n, dr.addEventListener("popstate", ga), 0 > dr.navigator.userAgent.indexOf("Trident") || dr.addEventListener("hashchange", ga), F2(function(r, t) {
                        if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || r.target || r.hasAttribute("download"))) {
                            t.preventDefault();
                            var e = r.href, a = fr(), u = Kt(e).a;
                            n(pa(u && a.bB === u.bB && a.bh === u.bh && a.by.a === u.by.a ? {
                                $: 0,
                                a: u
                            } : function(n) {
                                return {
                                    $: 1,
                                    a: n
                                };
                            }(e)));
                        }
                    });
                },
                cH: function(n) {
                    return A3(va.cH, n, fr(), ga);
                },
                dJ: va.dJ,
                dH: va.dH,
                dp: va.dp
            }))(ft(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? p(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, da) : n.Elm = da;
}($a0b4f895e1596b3b$exports);


// This optional code is used to register a service worker.
// register() is not called by default.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.
// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://bit.ly/CRA-PWA
const $6b528e0c36449ff5$var$isLocalhost = Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $6b528e0c36449ff5$export$6503ec6e8aabbaf(config) {
    if ('serviceWorker' in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location.href);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
        window.addEventListener('load', ()=>{
            const swUrl = `${undefined}/service-worker.js`;
            if ($6b528e0c36449ff5$var$isLocalhost) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                $6b528e0c36449ff5$var$checkValidServiceWorker(swUrl, config);
                // Add some additional logging to localhost, pointing developers to the
                // service worker/PWA documentation.
                navigator.serviceWorker.ready.then(()=>{
                    console.log("This web app is being served cache-first by a service worker. To learn more, visit https://bit.ly/CRA-PWA");
                });
            } else // Is not localhost. Just register service worker
            $6b528e0c36449ff5$var$registerValidSW(swUrl, config);
        });
    }
}
function $6b528e0c36449ff5$var$registerValidSW(swUrl, config) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        // At this point, the updated precached content has been fetched,
                        // but the previous service worker will still serve the older
                        // content until all client tabs are closed.
                        console.log("New content is available and will be used when all tabs for this page are closed. See https://bit.ly/CRA-PWA.");
                        // Execute callback
                        if (config && config.onUpdate) config.onUpdate(registration);
                    } else {
                        // At this point, everything has been precached.
                        // It's the perfect time to display a
                        // "Content is cached for offline use." message.
                        console.log('Content is cached for offline use.');
                        // Execute callback
                        if (config && config.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error('Error during service worker registration:', error);
    });
}
function $6b528e0c36449ff5$var$checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get('content-type');
        if (response.status === 404 || contentType != null && contentType.indexOf('javascript') === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $6b528e0c36449ff5$var$registerValidSW(swUrl, config);
    }).catch(()=>{
        console.log('No internet connection found. App is running in offline mode.');
    });
}
function $6b528e0c36449ff5$export$d07f55d4c15c0440() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}


var $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root")
});
// Scrolling Logic for the dynamic header:
var $35da740d59af89ba$var$_window = window;
var $35da740d59af89ba$var$_document = $35da740d59af89ba$var$_window.document;
var $35da740d59af89ba$var$_body = $35da740d59af89ba$var$_document.body;
var $35da740d59af89ba$var$_html = $35da740d59af89ba$var$_document.documentElement;
var $35da740d59af89ba$var$scrollTimer = null;
var $35da740d59af89ba$var$lastScrollFireTime = 0;
var $35da740d59af89ba$var$minScrollTime = 200;
document.body.onscroll = function(event) {
    event.returnValue = false;
    if ($35da740d59af89ba$var$scrollTimer) ;
    else {
        var now = new Date().getTime();
        if (now - $35da740d59af89ba$var$lastScrollFireTime > 3 * $35da740d59af89ba$var$minScrollTime) {
            $35da740d59af89ba$var$processScrollOrResize();
            $35da740d59af89ba$var$lastScrollFireTime = now;
        }
        $35da740d59af89ba$var$scrollTimer = setTimeout(function() {
            $35da740d59af89ba$var$scrollTimer = null;
            $35da740d59af89ba$var$lastScrollFireTime = new Date().getTime();
            $35da740d59af89ba$var$processScrollOrResize();
        }, $35da740d59af89ba$var$minScrollTime);
    }
};
var $35da740d59af89ba$var$processScrollOrResize = function() {
    var screenData = {
        scrollTop: parseInt(window.pageYOffset || $35da740d59af89ba$var$_html.scrollTop || $35da740d59af89ba$var$_body.scrollTop || 0),
        pageHeight: parseInt(Math.max(document.body.scrollHeight, document.body.offsetHeight, $35da740d59af89ba$var$_html.clientHeight, $35da740d59af89ba$var$_html.scrollHeight, $35da740d59af89ba$var$_html.offsetHeight)),
        viewportHeight: parseInt($35da740d59af89ba$var$_html.clientHeight),
        viewportWidth: parseInt($35da740d59af89ba$var$_html.clientWidth)
    };
    var Viewport = {
        scene: {
            height: screenData.pageHeight,
            width: screenData.viewportWidth
        },
        viewport: {
            height: screenData.viewportHeight,
            width: screenData.viewportWidth,
            x: 0,
            y: screenData.scrollTop
        }
    };
    $35da740d59af89ba$var$app.ports.messageReceiver.send(Viewport);
};
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
$6b528e0c36449ff5$export$d07f55d4c15c0440();


//# sourceMappingURL=kana-party-website.572dec90.js.map
